var _rect, _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path0, _g9, _path1, _g0, _path10, _g1, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g10, _path19, _g11, _path20, _g12, _path21, _g13, _path22, _g14, _path23, _g15, _path24, _g16, _path25, _g17, _path26, _g18, _path27, _g19, _path28, _g20, _path29, _g21, _path30, _g22, _path31, _g23, _path32, _g24, _path33, _g25, _path34, _g26, _path35, _g27, _path36, _g28, _path37, _g29, _path38, _g30, _path39, _g31, _path40, _g32, _path41, _g33, _path42, _g34, _path43, _g35, _path44, _g36, _path45, _g37, _path46, _g38, _path47, _g39, _path48, _g40, _path49, _g41, _path50, _g42, _path51, _g43, _path52, _g44, _path53, _g45, _path54, _g46, _path55, _g47, _path56, _g48, _path57, _g49, _path58, _g50, _path59, _g51, _path60, _g52, _path61, _g53, _path62, _g54, _path63, _g55, _path64, _g56, _path65, _g57, _path66, _g58, _path67, _g59, _path68, _g60, _path69, _g61, _path70, _g62, _path71, _g63, _path72, _g64, _path73, _g65, _path74, _g66, _path75, _g67, _path76, _g68, _path77, _g69, _path78, _g70, _path79, _g71, _path80, _g72, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _g73, _path91, _g74, _path92, _g75, _path93, _g76, _path94, _g77, _path95, _g78, _path96, _g79, _path97, _g80, _path98, _g81, _path99, _g82, _path100, _g83, _path101, _g84, _path102, _g85, _path103, _g86, _path104, _g87, _path105, _g88, _path106, _g89, _path107, _g90, _path108, _g91, _path109, _g92, _path110, _g93, _path111, _g94, _path112, _g95, _path113, _g96, _path114, _g97, _path115, _g98, _path116, _g99, _path117, _g100, _path118, _g101, _path119, _g102, _path120, _g103, _path121, _g104, _path122, _g105, _path123, _g106, _path124, _g107, _path125, _g108, _path126, _g109, _path127, _g110, _path128, _g111, _path129, _g112, _path130, _g113, _path131, _g114, _path132, _g115, _path133, _g116, _path134, _g117, _path135, _g118, _path136, _g119, _path137, _g120, _path138, _g121, _path139, _g122, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _g123, _path155, _g124, _path156, _g125, _path157, _g126, _path158, _g127, _path159, _g128, _path160, _g129, _path161, _g130, _path162, _g131, _path163, _g132, _path164, _g133, _path165, _g134, _path166, _g135, _path167, _g136, _path168, _g137, _path169, _g138, _path170, _g139, _path171, _g140, _path172, _g141, _path173, _g142, _path174, _g143, _path175, _g144, _path176, _g145, _path177, _g146, _path178, _g147, _path179, _g148, _path180, _g149, _path181, _g150, _path182, _g151, _path183, _g152, _path184, _g153, _path185, _g154, _path186, _g155, _path187, _g156, _path188, _g157, _path189, _g158, _path190, _g159, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _g160, _path201, _g161, _path202, _g162, _path203, _g163, _path204, _g164, _path205, _g165, _path206, _g166, _path207, _g167, _path208, _g168, _path209, _g169, _path210, _g170, _path211, _g171, _path212, _g172, _path213, _g173, _path214, _g174, _path215, _g175, _path216, _g176, _path217, _g177, _path218, _g178, _path219, _g179, _path220, _g180, _path221, _g181, _path222, _g182, _path223, _g183, _path224, _g184, _path225, _g185, _path226, _g186, _path227, _g187, _path228, _g188, _path229, _g189, _path230, _g190, _path231, _g191, _path232, _g192, _path233, _g193, _path234, _g194, _path235, _g195, _path236, _g196, _path237, _g197, _path238, _g198, _path239, _g199, _path240, _g200, _path241, _g201, _path242, _g202, _path243, _g203, _path244, _g204, _path245, _g205, _path246, _g206, _path247, _g207, _path248, _g208, _path249, _g209, _path250, _g210, _path251, _g211, _path252, _g212, _path253, _g213, _path254, _g214, _path255, _g215, _path256, _g216, _path257, _g217, _path258, _g218, _path259, _g219, _path260, _g220, _path261, _path262, _path263, _path264, _path265, _path266, _g221, _path267, _g222, _path268, _g223, _path269, _g224, _path270, _g225, _path271, _g226, _path272, _g227, _path273, _g228, _path274, _g229, _path275, _g230, _path276, _g231, _path277, _g232, _path278, _g233, _path279, _g234, _path280, _g235, _path281, _g236, _path282, _g237, _path283, _g238, _path284, _g239, _path285, _g240, _path286, _g241, _path287, _g242, _path288, _g243, _path289, _g244, _path290, _g245, _path291, _g246, _path292, _g247, _path293, _g248, _path294, _g249, _path295, _g250, _path296, _g251, _path297, _g252, _path298, _g253, _path299, _g254, _path300, _g255, _path301, _g256, _path302, _g257, _path303, _g258, _path304, _g259, _path305, _g260, _path306, _g261, _path307, _g262, _path308, _g263, _path309, _g264, _path310, _g265, _path311, _g266, _path312, _g267, _path313, _g268, _path314, _g269, _path315, _g270, _path316, _g271, _path317, _g272, _path318, _g273, _path319, _g274, _path320, _g275, _path321, _g276, _path322, _g277, _path323, _g278, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _g279, _path332, _g280, _path333, _path334, _path335, _g281, _path336, _g282, _path337, _g283, _path338, _g284, _path339, _g285, _path340, _g286, _path341, _g287, _path342, _g288, _path343, _g289, _path344, _g290, _path345, _g291, _path346, _g292, _path347, _g293, _path348, _g294, _path349, _g295, _path350, _g296, _path351, _g297, _path352, _g298, _path353, _g299, _path354, _g300, _path355, _g301, _path356, _g302, _path357, _g303, _path358, _g304, _path359, _g305, _path360, _g306, _path361, _g307, _path362, _g308, _path363, _g309, _path364, _g310, _path365, _g311, _path366, _g312, _path367, _g313, _path368, _g314, _path369, _g315, _path370, _g316, _path371, _path372, _path373, _g317, _path374, _g318, _path375, _g319, _path376, _g320, _path377, _g321, _path378, _g322, _path379, _g323, _path380, _g324, _path381, _g325, _path382, _g326, _path383, _g327, _path384, _g328, _path385, _g329, _path386, _g330, _path387, _g331, _path388, _g332, _path389, _g333, _path390, _g334, _path391, _g335, _path392, _g336, _path393, _g337, _path394, _g338, _path395, _g339, _path396, _g340, _path397, _g341, _path398, _g342, _path399, _g343, _path400, _g344, _path401, _g345, _path402, _g346, _path403, _g347, _path404, _g348, _path405, _g349, _path406, _g350, _path407, _g351, _path408, _g352, _path409, _g353, _path410, _g354, _path411, _g355, _path412, _g356, _path413, _g357, _path414, _g358, _path415, _g359, _path416, _g360, _path417, _g361, _path418, _g362, _path419, _g363, _path420, _g364, _path421, _g365, _path422, _g366, _path423, _g367, _path424, _g368, _path425, _g369, _path426, _g370, _path427, _g371, _path428, _g372, _path429, _g373, _path430, _g374, _path431, _g375, _path432, _g376, _path433, _g377, _path434, _g378, _path435, _g379, _path436, _g380, _path437, _g381, _path438, _g382, _path439, _g383, _path440, _g384, _path441, _g385, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _g386, _path461, _g387, _path462, _g388, _path463, _g389, _path464, _g390, _path465, _g391, _path466, _g392, _path467, _g393, _path468, _g394, _path469, _g395, _path470, _g396, _path471, _g397, _path472, _g398, _path473, _g399, _path474, _g400, _path475, _g401, _path476, _g402, _path477, _g403, _path478, _g404, _path479, _g405, _path480, _g406, _path481, _g407, _path482, _g408, _path483, _g409, _path484, _g410, _path485, _g411, _path486, _g412, _path487, _g413, _path488, _g414, _path489, _g415, _path490, _g416, _path491, _g417, _path492, _g418, _path493, _g419, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManWithCoin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 570,
    height: 380,
    viewBox: "0 0 570 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_1444)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 570,
    height: 380,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M570 0H0V380H570V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 61,
    width: 553,
    height: 303
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M550.233 354.331C516.65 321.987 552.453 261.129 524.826 223.57C509.543 202.793 483.87 192.597 458.955 185.928C434.041 179.258 407.945 174.869 385.797 161.652C359.338 145.862 341.521 119.333 320.733 96.5896C299.945 73.8466 272.637 59.5212 241.951 62.2999C221.881 64.1173 204.019 75.7819 188.942 89.1515C173.864 102.521 160.004 111.689 143.761 123.616C112.339 146.692 69.291 157.528 50.4276 191.646C40.7778 209.099 39.4007 229.768 38.1668 249.673C36.9328 269.578 35.4036 290.266 25.5148 307.585C15.6259 324.904 26.8132 341.718 7.79004 335.73C18.4734 352.704 6.28818 354.066 26.1909 356.545C209.648 379.393 375.056 337.63 559.092 355.214C556.409 354.445 552.243 356.267 550.233 354.331Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M556.911 59.5212L557.013 71.2743L6.28821 76.0424V59.5212H556.911Z",
    fill: "#F7F6FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 61,
    width: 553,
    height: 303
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M550.233 354.331C516.65 321.987 552.453 261.129 524.826 223.57C509.543 202.793 483.87 192.597 458.955 185.928C434.041 179.258 407.945 174.869 385.797 161.652C359.338 145.862 341.521 119.333 320.733 96.5896C299.945 73.8466 272.637 59.5212 241.951 62.2999C221.881 64.1173 204.019 75.7819 188.942 89.1515C173.864 102.521 160.004 111.689 143.761 123.616C112.339 146.692 69.291 157.528 50.4276 191.646C40.7778 209.099 39.4007 229.768 38.1668 249.673C36.9328 269.578 35.4036 290.266 25.5148 307.585C15.6259 324.904 26.8132 341.718 7.79004 335.73C18.4734 352.704 6.28818 354.066 26.1909 356.545C209.648 379.393 375.056 337.63 559.092 355.214C556.409 354.445 552.243 356.267 550.233 354.331Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557.013 71.2742L557.24 97.4622L6.28821 102.232V76.0423L557.013 71.2742Z",
    fill: "#F8F7FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 61,
    width: 553,
    height: 303
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M550.233 354.331C516.65 321.987 552.453 261.129 524.826 223.57C509.543 202.793 483.87 192.597 458.955 185.928C434.041 179.258 407.945 174.869 385.797 161.652C359.338 145.862 341.521 119.333 320.733 96.5896C299.945 73.8466 272.637 59.5212 241.951 62.2999C221.881 64.1173 204.019 75.7819 188.942 89.1515C173.864 102.521 160.004 111.689 143.761 123.616C112.339 146.692 69.291 157.528 50.4276 191.646C40.7778 209.099 39.4007 229.768 38.1668 249.673C36.9328 269.578 35.4036 290.266 25.5148 307.585C15.6259 324.904 26.8132 341.718 7.79004 335.73C18.4734 352.704 6.28818 354.066 26.1909 356.545C209.648 379.393 375.056 337.63 559.092 355.214C556.409 354.445 552.243 356.267 550.233 354.331Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557.24 97.4622L557.467 123.65L6.28821 128.422V102.232L557.24 97.4622Z",
    fill: "#F9F8FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 61,
    width: 553,
    height: 303
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M550.233 354.331C516.65 321.987 552.453 261.129 524.826 223.57C509.543 202.793 483.87 192.597 458.955 185.928C434.041 179.258 407.945 174.869 385.797 161.652C359.338 145.862 341.521 119.333 320.733 96.5896C299.945 73.8466 272.637 59.5212 241.951 62.2999C221.881 64.1173 204.019 75.7819 188.942 89.1515C173.864 102.521 160.004 111.689 143.761 123.616C112.339 146.692 69.291 157.528 50.4276 191.646C40.7778 209.099 39.4007 229.768 38.1668 249.673C36.9328 269.578 35.4036 290.266 25.5148 307.585C15.6259 324.904 26.8132 341.718 7.79004 335.73C18.4734 352.704 6.28818 354.066 26.1909 356.545C209.648 379.393 375.056 337.63 559.092 355.214C556.409 354.445 552.243 356.267 550.233 354.331Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557.467 123.65L557.693 149.838L6.28821 154.613V128.423L557.467 123.65Z",
    fill: "#FAF9FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 61,
    width: 553,
    height: 303
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M550.233 354.331C516.65 321.987 552.453 261.129 524.826 223.57C509.543 202.793 483.87 192.597 458.955 185.928C434.041 179.258 407.945 174.869 385.797 161.652C359.338 145.862 341.521 119.333 320.733 96.5896C299.945 73.8466 272.637 59.5212 241.951 62.2999C221.881 64.1173 204.019 75.7819 188.942 89.1515C173.864 102.521 160.004 111.689 143.761 123.616C112.339 146.692 69.291 157.528 50.4276 191.646C40.7778 209.099 39.4007 229.768 38.1668 249.673C36.9328 269.578 35.4036 290.266 25.5148 307.585C15.6259 324.904 26.8132 341.718 7.79004 335.73C18.4734 352.704 6.28818 354.066 26.1909 356.545C209.648 379.393 375.056 337.63 559.092 355.214C556.409 354.445 552.243 356.267 550.233 354.331Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557.693 149.838L557.92 176.026L6.28821 180.802V154.613L557.693 149.838Z",
    fill: "#FBFAFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 61,
    width: 553,
    height: 303
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M550.233 354.331C516.65 321.987 552.453 261.129 524.826 223.57C509.543 202.793 483.87 192.597 458.955 185.928C434.041 179.258 407.945 174.869 385.797 161.652C359.338 145.862 341.521 119.333 320.733 96.5896C299.945 73.8466 272.637 59.5212 241.951 62.2999C221.881 64.1173 204.019 75.7819 188.942 89.1515C173.864 102.521 160.004 111.689 143.761 123.616C112.339 146.692 69.291 157.528 50.4276 191.646C40.7778 209.099 39.4007 229.768 38.1668 249.673C36.9328 269.578 35.4036 290.266 25.5148 307.585C15.6259 324.904 26.8132 341.718 7.79004 335.73C18.4734 352.704 6.28818 354.066 26.1909 356.545C209.648 379.393 375.056 337.63 559.092 355.214C556.409 354.445 552.243 356.267 550.233 354.331Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557.92 176.027L558.147 202.215L6.28821 206.993V180.803L557.92 176.027Z",
    fill: "#FCFBFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 61,
    width: 553,
    height: 303
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M550.233 354.331C516.65 321.987 552.453 261.129 524.826 223.57C509.543 202.793 483.87 192.597 458.955 185.928C434.041 179.258 407.945 174.869 385.797 161.652C359.338 145.862 341.521 119.333 320.733 96.5896C299.945 73.8466 272.637 59.5212 241.951 62.2999C221.881 64.1173 204.019 75.7819 188.942 89.1515C173.864 102.521 160.004 111.689 143.761 123.616C112.339 146.692 69.291 157.528 50.4276 191.646C40.7778 209.099 39.4007 229.768 38.1668 249.673C36.9328 269.578 35.4036 290.266 25.5148 307.585C15.6259 324.904 26.8132 341.718 7.79004 335.73C18.4734 352.704 6.28818 354.066 26.1909 356.545C209.648 379.393 375.056 337.63 559.092 355.214C556.409 354.445 552.243 356.267 550.233 354.331Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M558.147 202.215L558.374 228.403L6.28821 233.183V206.993L558.147 202.215Z",
    fill: "#FCFCFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 61,
    width: 553,
    height: 303
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M550.233 354.331C516.65 321.987 552.453 261.129 524.826 223.57C509.543 202.793 483.87 192.597 458.955 185.928C434.041 179.258 407.945 174.869 385.797 161.652C359.338 145.862 341.521 119.333 320.733 96.5896C299.945 73.8466 272.637 59.5212 241.951 62.2999C221.881 64.1173 204.019 75.7819 188.942 89.1515C173.864 102.521 160.004 111.689 143.761 123.616C112.339 146.692 69.291 157.528 50.4276 191.646C40.7778 209.099 39.4007 229.768 38.1668 249.673C36.9328 269.578 35.4036 290.266 25.5148 307.585C15.6259 324.904 26.8132 341.718 7.79004 335.73C18.4734 352.704 6.28818 354.066 26.1909 356.545C209.648 379.393 375.056 337.63 559.092 355.214C556.409 354.445 552.243 356.267 550.233 354.331Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M558.374 228.403L558.6 254.591L6.28821 259.373V233.183L558.374 228.403Z",
    fill: "#FDFDFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 61,
    width: 553,
    height: 303
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M550.233 354.331C516.65 321.987 552.453 261.129 524.826 223.57C509.543 202.793 483.87 192.597 458.955 185.928C434.041 179.258 407.945 174.869 385.797 161.652C359.338 145.862 341.521 119.333 320.733 96.5896C299.945 73.8466 272.637 59.5212 241.951 62.2999C221.881 64.1173 204.019 75.7819 188.942 89.1515C173.864 102.521 160.004 111.689 143.761 123.616C112.339 146.692 69.291 157.528 50.4276 191.646C40.7778 209.099 39.4007 229.768 38.1668 249.673C36.9328 269.578 35.4036 290.266 25.5148 307.585C15.6259 324.904 26.8132 341.718 7.79004 335.73C18.4734 352.704 6.28818 354.066 26.1909 356.545C209.648 379.393 375.056 337.63 559.092 355.214C556.409 354.445 552.243 356.267 550.233 354.331Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M558.6 254.591L558.827 280.779L6.28821 285.563V259.373L558.6 254.591Z",
    fill: "#FEFEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 61,
    width: 553,
    height: 303
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M550.233 354.331C516.65 321.987 552.453 261.129 524.826 223.57C509.543 202.793 483.87 192.597 458.955 185.928C434.041 179.258 407.945 174.869 385.797 161.652C359.338 145.862 341.521 119.333 320.733 96.5896C299.945 73.8466 272.637 59.5212 241.951 62.2999C221.881 64.1173 204.019 75.7819 188.942 89.1515C173.864 102.521 160.004 111.689 143.761 123.616C112.339 146.692 69.291 157.528 50.4276 191.646C40.7778 209.099 39.4007 229.768 38.1668 249.673C36.9328 269.578 35.4036 290.266 25.5148 307.585C15.6259 324.904 26.8132 341.718 7.79004 335.73C18.4734 352.704 6.28818 354.066 26.1909 356.545C209.648 379.393 375.056 337.63 559.092 355.214C556.409 354.445 552.243 356.267 550.233 354.331Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M558.827 280.779L559.054 306.967L6.28821 311.753V285.563L558.827 280.779Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 61,
    width: 553,
    height: 303
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M550.233 354.331C516.65 321.987 552.453 261.129 524.826 223.57C509.543 202.793 483.87 192.597 458.955 185.928C434.041 179.258 407.945 174.869 385.797 161.652C359.338 145.862 341.521 119.333 320.733 96.5896C299.945 73.8466 272.637 59.5212 241.951 62.2999C221.881 64.1173 204.019 75.7819 188.942 89.1515C173.864 102.521 160.004 111.689 143.761 123.616C112.339 146.692 69.291 157.528 50.4276 191.646C40.7778 209.099 39.4007 229.768 38.1668 249.673C36.9328 269.578 35.4036 290.266 25.5148 307.585C15.6259 324.904 26.8132 341.718 7.79004 335.73C18.4734 352.704 6.28818 354.066 26.1909 356.545C209.648 379.393 375.056 337.63 559.092 355.214C556.409 354.445 552.243 356.267 550.233 354.331Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.054 306.967L559.092 311.323V379.393H6.28821V311.753L559.054 306.967Z",
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M513.325 294.984C513.325 294.984 514.918 297.845 517.64 304.421C519.211 303.399 520.764 302.301 522.297 301.127L541.247 286.608L523.865 279.424C502.29 270.507 480.161 273.939 461.272 289.132L442.192 304.479L467.749 312.043C483.846 316.808 500.001 314.77 514.678 306.242L513.325 294.984Z",
    fill: "#A6BDFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M452.559 301.904C452.487 301.904 452.423 301.852 452.41 301.779C452.396 301.697 452.451 301.619 452.533 301.605L535.859 287.114C535.941 287.1 536.019 287.155 536.033 287.237C536.048 287.319 535.993 287.397 535.911 287.412L452.585 301.902C452.576 301.903 452.567 301.904 452.559 301.904Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M477.196 280.079C477.196 280.079 478.146 283.213 480.983 289.739C479.156 290.16 477.288 290.514 475.379 290.8L451.769 294.337L458.682 276.845C467.263 255.135 485.109 241.607 509.161 238.582L533.455 235.527L521.135 259.161C513.375 274.047 500.683 284.248 484.35 288.875L477.196 280.079Z",
    fill: "#C9D7FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M455.966 291.087C455.92 291.087 455.874 291.065 455.844 291.025C455.795 290.957 455.81 290.863 455.877 290.814L524.202 240.965C524.269 240.916 524.364 240.931 524.413 240.998C524.462 241.066 524.447 241.16 524.38 241.209L456.055 291.058C456.028 291.077 455.997 291.087 455.966 291.087Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2982 225.718C79.2982 225.718 77.2291 229.106 73.6127 236.936C71.759 235.622 69.9316 234.217 68.1331 232.721L45.8903 214.213L67.2916 206.36C93.855 196.612 120.488 201.848 142.623 221.169L164.982 240.685L133.662 248.6C113.936 253.586 94.47 250.331 77.1104 239.286L79.2982 225.718Z",
    fill: "#A6BDFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M152.56 237.061C152.547 237.061 152.534 237.06 152.522 237.057L52.3141 215.446C52.2154 215.425 52.1527 215.327 52.1739 215.229C52.1954 215.13 52.2931 215.068 52.3912 215.089L152.599 236.7C152.697 236.721 152.76 236.818 152.739 236.917C152.72 237.003 152.644 237.061 152.56 237.061Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M125.632 214.343C125.632 214.343 124.429 218.126 120.882 225.988C123.089 226.527 125.347 226.988 127.656 227.366L156.211 232.047L148.124 210.733C138.087 184.278 116.685 167.586 87.5855 163.518L58.1931 159.41L72.7305 188.259C81.8867 206.429 97.098 219.004 116.815 224.884L125.632 214.343Z",
    fill: "#C9D7FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M151.181 228.038C151.142 228.038 151.104 228.026 151.071 228.002L69.0972 166.448C69.0164 166.387 69 166.273 69.0607 166.192C69.1213 166.111 69.2359 166.095 69.3167 166.156L151.291 227.709C151.371 227.77 151.388 227.884 151.327 227.965C151.291 228.013 151.236 228.038 151.181 228.038Z",
    fill: "white"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.765 329.496C412.869 329.496 503.748 327.236 503.748 324.449C503.748 321.661 412.869 319.402 300.765 319.402C188.661 319.402 97.7831 321.661 97.7831 324.449C97.7831 327.236 188.661 329.496 300.765 329.496Z",
    fill: "#5C49D8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.4967 251.529L92.1105 289.914H90.4967V251.529Z",
    fill: "#8076DC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.4967 194.273L94.5177 289.914H92.1105L90.4967 251.529V194.273Z",
    fill: "#8177DD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.4967 137.017L96.9248 289.914H94.5177L90.4967 194.273V137.017Z",
    fill: "#8178DD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.5064 79.9924L99.3319 289.914H96.9248L90.4967 137.017V79.9924H90.5064Z",
    fill: "#8279DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.9135 79.9924L101.739 289.914H99.3319L90.5063 79.9924H92.9135Z",
    fill: "#827ADE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.3207 79.9924L104.146 289.914H101.739L92.9135 79.9924H95.3207Z",
    fill: "#837BDF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.7278 79.9924L106.553 289.914H104.146L95.3207 79.9924H97.7278Z",
    fill: "#847CDF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.135 79.9924L108.96 289.914H106.553L97.7278 79.9924H100.135Z",
    fill: "#847DE0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.542 79.9924L111.368 289.914H108.961L100.135 79.9924H102.542Z",
    fill: "#857EE0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.949 79.9924L113.775 289.914H111.368L102.542 79.9924H104.949Z",
    fill: "#857FE1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.356 79.9924L116.182 289.914H113.775L104.949 79.9924H107.356Z",
    fill: "#8680E1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.764 79.9924L118.589 289.914H116.182L107.356 79.9924H109.764Z",
    fill: "#8681E2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.171 79.9924L120.996 289.914H118.589L109.764 79.9924H112.171Z",
    fill: "#8782E2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.578 79.9924L123.403 289.914H120.996L112.171 79.9924H114.578Z",
    fill: "#8783E3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.985 79.9924L125.81 289.914H123.403L114.578 79.9924H116.985Z",
    fill: "#8884E3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.392 79.9924L128.218 289.914H125.81L116.985 79.9924H119.392Z",
    fill: "#8885E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.799 79.9924L130.625 289.914H128.218L119.392 79.9924H121.799Z",
    fill: "#8986E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.206 79.9924L133.032 289.914H130.625L121.799 79.9924H124.206Z",
    fill: "#8987E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.614 79.9924L135.439 289.914H133.032L124.206 79.9924H126.614Z",
    fill: "#8A88E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.021 79.9924L137.846 289.914H135.439L126.614 79.9924H129.021Z",
    fill: "#8B89E6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.428 79.9924L140.253 289.914H137.846L129.021 79.9924H131.428Z",
    fill: "#8B8AE6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.835 79.9924L142.661 289.914H140.253L131.428 79.9924H133.835Z",
    fill: "#8C8BE7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.242 79.9924L145.068 289.914H142.66L133.835 79.9924H136.242Z",
    fill: "#8C8CE7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.649 79.9924L147.475 289.914H145.068L136.242 79.9924H138.649Z",
    fill: "#8D8DE8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.056 79.9924L149.882 289.914H147.475L138.649 79.9924H141.056Z",
    fill: "#8D8EE8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.464 79.9924L152.289 289.914H149.882L141.056 79.9924H143.464Z",
    fill: "#8E8FE9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.871 79.9924L154.696 289.914H152.289L143.464 79.9924H145.871Z",
    fill: "#8E90E9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.278 79.9924L157.103 289.914H154.696L145.871 79.9924H148.278Z",
    fill: "#8F91EA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.685 79.9924L159.511 289.914H157.103L148.278 79.9924H150.685Z",
    fill: "#8F92EA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.092 79.9924L161.918 289.914H159.511L150.685 79.9924H153.092Z",
    fill: "#9093EB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.499 79.9924L164.325 289.914H161.918L153.092 79.9924H155.499Z",
    fill: "#9094EB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.906 79.9924L166.732 289.914H164.325L155.499 79.9924H157.906Z",
    fill: "#9196EC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.314 79.9924L169.139 289.914H166.732L157.906 79.9924H160.314Z",
    fill: "#9297EC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.721 79.9924L171.546 289.914H169.139L160.314 79.9924H162.721Z",
    fill: "#9298ED"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.128 79.9924L173.953 289.914H171.546L162.721 79.9924H165.128Z",
    fill: "#9399ED"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.535 79.9924L176.361 289.914H173.953L165.128 79.9924H167.535Z",
    fill: "#939AEE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.942 79.9924L178.768 289.914H176.361L167.535 79.9924H169.942Z",
    fill: "#949BEE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.349 79.9924L181.175 289.914H178.768L169.942 79.9924H172.349Z",
    fill: "#949CEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.756 79.9924L183.582 289.914H181.175L172.349 79.9924H174.756Z",
    fill: "#959DEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.164 79.9924L185.989 289.914H183.582L174.756 79.9924H177.164Z",
    fill: "#959EF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.571 79.9924L188.396 289.914H185.989L177.164 79.9924H179.571Z",
    fill: "#969FF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.978 79.9924L190.804 289.914H188.396L179.571 79.9924H181.978Z",
    fill: "#96A0F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.385 79.9924L193.211 289.914H190.804L181.978 79.9924H184.385Z",
    fill: "#97A1F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.792 79.9924L195.618 289.914H193.211L184.385 79.9924H186.792Z",
    fill: "#97A2F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.199 79.9924L198.025 289.914H195.618L186.792 79.9924H189.199Z",
    fill: "#98A3F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.607 79.9924L200.432 289.914H198.025L189.199 79.9924H191.607Z",
    fill: "#99A4F3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.014 79.9924L202.839 289.914H200.432L191.607 79.9924H194.014Z",
    fill: "#99A5F3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.421 79.9924L205.246 289.914H202.839L194.014 79.9924H196.421Z",
    fill: "#9AA6F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.828 79.9924L207.653 289.914H205.246L196.421 79.9924H198.828Z",
    fill: "#9AA7F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.235 79.9924L210.061 289.914H207.653L198.828 79.9924H201.235Z",
    fill: "#9BA8F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.642 79.9924L212.468 289.914H210.061L201.235 79.9924H203.642Z",
    fill: "#9BA9F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.049 79.9924L214.875 289.914H212.468L203.642 79.9924H206.049Z",
    fill: "#9CAAF6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.457 79.9924L217.282 289.914H214.875L206.049 79.9924H208.457Z",
    fill: "#9CABF6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.864 79.9924L219.689 289.914H217.282L208.457 79.9924H210.864Z",
    fill: "#9DACF7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.271 79.9924L222.096 289.914H219.689L210.864 79.9924H213.271Z",
    fill: "#9DADF7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.678 79.9924L224.503 289.914H222.096L213.271 79.9924H215.678Z",
    fill: "#9EAEF8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.085 79.9924L226.911 289.914H224.503L215.678 79.9924H218.085Z",
    fill: "#9EAFF8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.492 79.9924L228.914 280.321V289.914H226.911L218.085 79.9924H220.492Z",
    fill: "#9FB0F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.899 79.9924L228.914 223.065V280.321L220.492 79.9924H222.899Z",
    fill: "#A0B1F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.307 79.9924L228.914 165.81V223.065L222.899 79.9924H225.307Z",
    fill: "#A0B2FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.714 79.9924L228.914 108.554V165.81L225.307 79.9924H227.714Z",
    fill: "#A1B3FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 79,
    width: 137,
    height: 211
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M215.892 289.914H137.301C129.537 289.914 122.209 283.482 120.932 275.548L91.7734 94.3578C90.4967 86.424 95.7552 79.9924 103.519 79.9924H182.111C189.874 79.9924 197.203 86.4239 198.479 94.3576L227.638 275.548C228.914 283.482 223.656 289.914 215.892 289.914Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.914 108.554L227.714 79.9924H228.914V108.554Z",
    fill: "#A1B4FB"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M101.108 134.315C100.407 134.315 99.7462 133.735 99.631 133.019L97.5072 119.822C97.392 119.106 97.8665 118.526 98.567 118.526C99.2674 118.526 99.9286 119.106 100.044 119.822L102.168 133.019C102.283 133.735 101.808 134.315 101.108 134.315Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M105.799 163.469C105.099 163.469 104.438 162.888 104.323 162.173L100.777 140.142C100.662 139.426 101.137 138.846 101.837 138.846C102.537 138.846 103.199 139.426 103.314 140.142L106.859 162.173C106.974 162.888 106.5 163.469 105.799 163.469Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M216.318 286.18H140.741C135.232 286.18 130.031 281.616 129.125 275.986L99.8122 93.8338C98.9062 88.2038 102.638 83.6399 108.147 83.6399H183.724C189.233 83.6399 194.434 88.2039 195.34 93.8338L224.653 275.986C225.559 281.616 221.827 286.18 216.318 286.18Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M162.455 93.9719H137.662C136.332 93.9719 135.077 92.8908 134.865 91.562C134.759 90.9022 134.92 90.2818 135.318 89.815C135.709 89.3561 136.283 89.1033 136.932 89.1033H161.726C163.056 89.1033 164.311 90.1844 164.523 91.5131C164.629 92.173 164.468 92.7935 164.07 93.2602C163.678 93.7191 163.105 93.9719 162.455 93.9719ZM136.932 89.4122C136.375 89.4122 135.885 89.6265 135.553 90.0156C135.215 90.4124 135.079 90.9442 135.17 91.5132C135.359 92.6987 136.477 93.6631 137.662 93.6631H162.455C163.013 93.6631 163.503 93.4488 163.834 93.0597C164.173 92.6629 164.309 92.1311 164.218 91.562C164.028 90.3766 162.91 89.4122 161.726 89.4122H136.932Z",
    fill: "#5C49D8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M248.087 101.774C236.344 102.117 222.659 93.0017 217.521 81.4133C214.469 74.5296 215.119 68.3211 218.617 64.3448L222.291 59.7717L221.743 61.8118C223.851 60.6089 226.452 59.9004 229.482 59.8122C241.225 59.4691 254.91 68.5841 260.046 80.1714C261.99 84.5525 262.432 88.6608 261.595 92.0938L263.365 91.7634L259.538 96.5204C259.532 96.5274 259.528 96.5344 259.523 96.5414C257.177 99.6682 253.249 101.623 248.087 101.774Z",
    fill: "#FFB22E"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M223.822 74.0845L217.776 81.5229C220.239 86.9534 224.574 91.8278 229.694 95.4231L236.975 86.4655L223.822 74.0845Z",
    fill: "#FFBF52"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M235.29 88.6328C235.172 88.7784 231.29 93.5538 229.633 95.5933C231.977 97.2285 234.483 98.5954 237.048 99.6252L242.824 92.6041L235.29 88.6328Z",
    fill: "#FFD269"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M259.523 96.5416C259.528 96.5345 259.532 96.5276 259.538 96.5206L263.365 91.7635L261.595 92.0939C261.689 91.7098 261.764 91.316 261.825 90.9155L260.615 90.7666L250.515 94.3965L244.648 101.615C245.806 101.751 246.955 101.807 248.086 101.774C253.249 101.623 257.177 99.6684 259.523 96.5416Z",
    fill: "#FFE691"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M242.777 92.45L236.97 99.594C239.522 100.626 242.133 101.325 244.701 101.622L251.021 93.8461L242.777 92.45Z",
    fill: "#FFE078"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M263.99 91.0857C269.819 83.4777 265.29 70.2196 253.874 61.4728C242.458 52.726 228.478 51.8028 222.649 59.4108C216.82 67.0188 221.349 80.2769 232.765 89.0237C244.181 97.7705 258.161 98.6937 263.99 91.0857Z",
    fill: "#FFD269"
  })), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.583 74.6345C263.571 72.3512 262.226 70.1647 260.63 68.127L246.592 95.641C248.624 96.0839 250.651 96.2944 252.623 96.2367C255.69 96.1471 258.32 95.4202 260.442 94.1902L266.451 81.408C266.24 79.2712 265.629 76.9925 264.583 74.6345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.542 54.5842L225.702 81.9837C227.693 84.6056 230.102 86.9903 232.762 89.0274L246.519 57.0494C243.906 55.8593 241.209 55.0122 238.542 54.5842Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.7 87.0982L261.794 89.2872L225.881 60.0372L226.962 58.7952H263.7V87.0982Z",
    fill: "#FFE691"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.794 89.2871L261.428 89.7081L225.514 60.4581L225.881 60.0371L261.794 89.2871Z",
    fill: "#FFE691"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.428 89.708L261.062 90.129L225.148 60.8789L225.514 60.458L261.428 89.708Z",
    fill: "#FFE590"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.061 90.1289L260.695 90.5499L224.781 61.2999L225.148 60.8789L261.061 90.1289Z",
    fill: "#FFE48F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.695 90.5501L260.329 90.971L224.415 61.721L224.781 61.3L260.695 90.5501Z",
    fill: "#FFE48E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.329 90.971L259.962 91.3919L224.049 62.1419L224.415 61.7209L260.329 90.971Z",
    fill: "#FFE38D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.962 91.3919L259.68 91.7166H259.478L223.682 62.5628L224.049 62.1418L259.962 91.3919Z",
    fill: "#FEE28C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.594 91.7165L223.316 62.9837L223.682 62.5627L259.478 91.7165H258.594Z",
    fill: "#FEE18B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.711 91.7165L222.949 63.4046L223.316 62.9836L258.594 91.7165H257.711Z",
    fill: "#FEE08A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.828 91.7167L222.941 64.1179V63.4137L222.949 63.4048L257.711 91.7167H256.828Z",
    fill: "#FEE089"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.945 91.7165L222.941 64.837V64.1177L256.828 91.7165H255.945Z",
    fill: "#FEDF88"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.061 91.7167L222.941 65.5566V64.8372L255.945 91.7167H255.061Z",
    fill: "#FEDE87"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.178 91.7165L222.941 66.2757V65.5564L255.061 91.7165H254.178Z",
    fill: "#FEDD86"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.295 91.7166L222.941 66.9953V66.2759L254.178 91.7166H253.295Z",
    fill: "#FEDC85"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.411 91.7166L222.941 67.7147V66.9954L253.295 91.7166H252.411Z",
    fill: "#FEDC84"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.528 91.7165L222.941 68.434V67.7146L252.411 91.7165H251.528Z",
    fill: "#FEDB83"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.645 91.7166L222.941 69.1534V68.4341L251.528 91.7166H250.645Z",
    fill: "#FDDA82"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.762 91.7165L222.941 69.8728V69.1533L250.645 91.7165H249.762Z",
    fill: "#FDD981"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.878 91.7165L222.941 70.5921V69.8728L249.762 91.7165H248.878Z",
    fill: "#FDD880"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.995 91.7167L222.941 71.3117V70.5923L248.878 91.7167H247.995Z",
    fill: "#FDD87F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.112 91.7165L222.941 72.0309V71.3115L247.995 91.7165H247.112Z",
    fill: "#FDD77E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.228 91.7166L222.941 72.7504V72.031L247.112 91.7166H246.228Z",
    fill: "#FDD67D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.345 91.7167L222.941 73.4699V72.7505L246.228 91.7167H245.345Z",
    fill: "#FDD57C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.462 91.7165L222.941 74.1891V73.4697L245.345 91.7165H244.462Z",
    fill: "#FDD47B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.579 91.7166L222.941 74.9086V74.1892L244.462 91.7166H243.579Z",
    fill: "#FDD47A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask98_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.695 91.7167L222.941 75.628V74.9087L243.579 91.7167H242.695Z",
    fill: "#FDD379"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask99_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.812 91.7166L222.941 76.3474V75.6279L242.695 91.7166H241.812Z",
    fill: "#FCD278"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask100_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.929 91.7166L222.941 77.0668V76.3474L241.812 91.7166H240.929Z",
    fill: "#FCD177"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask101_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.045 91.7165L222.941 77.7861V77.0667L240.929 91.7165H240.045Z",
    fill: "#FCD076"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask102_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.162 91.7166L222.941 78.5055V77.7861L240.045 91.7166H239.162Z",
    fill: "#FCD075"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask103_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.279 91.7164L222.941 79.2248V78.5054L239.162 91.7164H238.279Z",
    fill: "#FCCF74"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask104_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.396 91.7165L222.941 79.9442V79.2249L238.279 91.7165H237.396Z",
    fill: "#FCCE72"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask105_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.512 91.7166L222.941 80.6638V79.9443L237.396 91.7166H236.512Z",
    fill: "#FCCD71"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask106_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.629 91.7164L222.941 81.3829V80.6636L236.512 91.7164H235.629Z",
    fill: "#FCCD70"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask107_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.746 91.7166L222.941 82.1025V81.3831L235.629 91.7166H234.746Z",
    fill: "#FCCC6F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask108_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.862 91.7166L222.941 82.822V82.1025L234.746 91.7166H233.862Z",
    fill: "#FCCB6E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask109_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.979 91.7167L222.941 83.5414V82.822L233.862 91.7167H232.979Z",
    fill: "#FBCA6D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask110_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.096 91.7166L222.941 84.2607V83.5413L232.979 91.7166H232.096Z",
    fill: "#FBC96C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask111_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.213 91.7166L222.941 84.9801V84.2607L232.096 91.7166H231.213Z",
    fill: "#FBC96B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask112_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.329 91.7165L222.941 85.6994V84.98L231.213 91.7165H230.329Z",
    fill: "#FBC86A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask113_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.446 91.7166L222.941 86.4188V85.6995L230.329 91.7166H229.446Z",
    fill: "#FBC769"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask114_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask114_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.563 91.7165L222.941 87.1381V86.4187L229.446 91.7165H228.563Z",
    fill: "#FBC668"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask115_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask115_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.68 91.7165L222.941 87.8575V87.1382L228.563 91.7165H227.68Z",
    fill: "#FBC567"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask116_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask116_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.796 91.7167L222.941 88.5771V87.8577L227.68 91.7167H226.796Z",
    fill: "#FBC566"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask117_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask117_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.913 91.7165L222.941 89.2962V88.5769L226.796 91.7165H225.913Z",
    fill: "#FBC465"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask118_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask118_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.03 91.7166L222.941 90.0158V89.2964L225.913 91.7166H225.03Z",
    fill: "#FBC364"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask119_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask119_74_1444)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask120_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask120_74_1444)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask121_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 59,
    width: 37,
    height: 33
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M259.276 87.4736C263.775 81.6008 260.279 71.3664 251.467 64.6145C242.654 57.8626 231.863 57.15 227.363 63.0228C222.864 68.8956 226.36 79.13 235.172 85.8819C243.984 92.6338 254.776 93.3464 259.276 87.4736Z",
    fill: "white"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask121_74_1444)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M250.007 91.5692C241.029 91.5694 230.71 84.5848 226.806 75.7801C224.799 71.2519 224.798 66.8276 226.805 63.6417C228.634 60.7383 231.948 59.0718 236.136 58.9494C245.232 58.6839 255.859 65.7635 259.835 74.7312C261.843 79.2596 261.843 83.6839 259.837 86.8697C258.008 89.7732 254.694 91.4395 250.505 91.562C250.34 91.5668 250.173 91.5692 250.007 91.5692ZM236.636 59.163C236.471 59.163 236.307 59.1654 236.143 59.1702C232.03 59.2904 228.78 60.9202 226.992 63.7595C225.025 66.882 225.031 71.2306 227.009 75.6905C230.88 84.4212 241.108 91.3474 250.005 91.3482C250.171 91.3482 250.334 91.3458 250.499 91.341C254.611 91.2208 257.861 89.5911 259.65 86.7519C261.616 83.6293 261.61 79.2806 259.633 74.8207C255.762 66.0901 245.533 59.163 236.636 59.163Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M250.701 77.9385C251.051 78.6469 251.234 79.3013 251.251 79.902C251.269 80.5029 251.134 81.0307 250.847 81.4853C250.559 81.9401 250.12 82.3193 249.53 82.623C248.94 82.9267 248.216 83.1353 247.358 83.2484L248.489 86.1524C248.506 86.2062 248.516 86.2584 248.518 86.3088C248.52 86.3591 248.497 86.4023 248.451 86.4382C248.405 86.4738 248.331 86.5049 248.23 86.5315C248.129 86.5577 247.99 86.5778 247.814 86.5915C247.612 86.6074 247.446 86.6088 247.317 86.5961C247.187 86.5833 247.079 86.5641 246.994 86.5387C246.908 86.5132 246.84 86.4726 246.79 86.4167C246.739 86.3608 246.705 86.2968 246.688 86.2247L245.578 83.3328C245.13 83.3128 244.704 83.275 244.302 83.219C243.9 83.1634 243.535 83.0979 243.205 83.0224C242.876 82.9471 242.586 82.864 242.336 82.7733C242.085 82.6826 241.891 82.5945 241.753 82.5087C241.615 82.4231 241.491 82.3065 241.382 82.1587C241.272 82.0108 241.152 81.8042 241.021 81.5386C240.925 81.344 240.854 81.1817 240.809 81.0519C240.763 80.9223 240.737 80.814 240.731 80.727C240.725 80.6402 240.742 80.5791 240.784 80.5435C240.826 80.5082 240.887 80.4873 240.966 80.481C241.08 80.4721 241.275 80.5236 241.549 80.6352C241.823 80.747 242.172 80.8669 242.596 80.9944C243.02 81.1221 243.515 81.2327 244.082 81.3261C244.649 81.4195 245.284 81.4386 245.987 81.3834C247.236 81.2855 248.062 80.9635 248.464 80.4169C248.866 79.8706 248.857 79.1724 248.438 78.3226C248.181 77.8003 247.847 77.3738 247.437 77.0426C247.028 76.7117 246.565 76.4354 246.049 76.2136C245.533 75.9921 244.982 75.8101 244.396 75.6676C243.81 75.5252 243.214 75.381 242.607 75.2354C242.001 75.0899 241.391 74.9171 240.776 74.717C240.162 74.5169 239.573 74.2551 239.012 73.9313C238.45 73.6077 237.926 73.2007 237.437 72.7102C236.949 72.2198 236.521 71.6028 236.155 70.8593C235.863 70.2664 235.691 69.705 235.64 69.1756C235.589 68.6465 235.671 68.1733 235.886 67.7566C236.101 67.3397 236.456 66.9855 236.951 66.6937C237.447 66.4021 238.091 66.1976 238.883 66.0804L237.824 63.3773C237.807 63.3236 237.797 63.2716 237.795 63.2212C237.793 63.1709 237.814 63.1255 237.858 63.0851C237.902 63.0451 237.974 63.0141 238.073 62.9924C238.172 62.9709 238.314 62.9528 238.498 62.9383C238.692 62.9231 238.857 62.9195 238.993 62.9273C239.129 62.9351 239.24 62.9561 239.326 62.9909C239.411 63.0255 239.476 63.0687 239.52 63.1205C239.563 63.1722 239.603 63.2336 239.638 63.3043L240.656 65.9827C240.933 65.9886 241.231 66.0136 241.55 66.0575C241.868 66.1016 242.174 66.1558 242.466 66.2202C242.758 66.2848 243.03 66.3599 243.282 66.4457C243.535 66.5318 243.716 66.6072 243.826 66.6721C243.935 66.7373 244.021 66.7995 244.082 66.8588C244.143 66.9185 244.202 66.9874 244.259 67.0656C244.316 67.1441 244.377 67.2358 244.443 67.3409C244.509 67.4461 244.574 67.5652 244.64 67.6978C244.722 67.8661 244.788 68.0128 244.836 68.1377C244.884 68.2628 244.912 68.3617 244.92 68.4345C244.929 68.5075 244.92 68.5634 244.893 68.6021C244.867 68.641 244.823 68.6628 244.761 68.6676C244.664 68.6752 244.482 68.6298 244.214 68.5313C243.947 68.4328 243.619 68.3295 243.233 68.2221C242.846 68.1143 242.414 68.0196 241.935 67.9377C241.456 67.8558 240.957 67.835 240.438 67.8757C239.849 67.9219 239.374 68.019 239.013 68.1669C238.652 68.3147 238.393 68.5029 238.236 68.7312C238.079 68.9595 238.014 69.2244 238.039 69.5258C238.064 69.8273 238.162 70.1506 238.332 70.4959C238.594 71.027 238.933 71.4603 239.349 71.7953C239.766 72.1305 240.231 72.4068 240.744 72.6238C241.258 72.8411 241.809 73.0185 242.397 73.1562C242.986 73.2941 243.589 73.4375 244.206 73.5867C244.823 73.7361 245.439 73.9061 246.053 74.0969C246.668 74.2879 247.258 74.5451 247.824 74.8684C248.39 75.1917 248.92 75.5985 249.412 76.0884C249.905 76.5782 250.335 77.1948 250.701 77.9385Z",
    fill: "#FFBF52"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M215.688 73.6572C215.664 73.6572 215.639 73.6491 215.619 73.6324C215.571 73.5939 215.564 73.5243 215.603 73.4769L219.962 68.1129C220.001 68.0654 220.07 68.0583 220.118 68.0968C220.165 68.1353 220.172 68.2049 220.134 68.2522L215.774 73.6163C215.752 73.6432 215.72 73.6572 215.688 73.6572Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M217.757 81.6806C217.733 81.6806 217.708 81.6726 217.688 81.6559C217.64 81.6174 217.633 81.5477 217.672 81.5004L222.031 76.1364C222.07 76.089 222.14 76.0816 222.187 76.1203C222.234 76.1588 222.241 76.2284 222.203 76.2757L217.843 81.6398C217.821 81.6667 217.79 81.6806 217.757 81.6806Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M222.778 89.3359C222.753 89.3359 222.729 89.3278 222.708 89.3111C222.661 89.2726 222.654 89.203 222.692 89.1557L227.024 83.8263C227.062 83.7789 227.132 83.7716 227.179 83.8102C227.227 83.8487 227.234 83.9183 227.195 83.9656L222.864 89.295C222.842 89.3219 222.81 89.3359 222.778 89.3359Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M229.683 95.5244C229.658 95.5244 229.634 95.5163 229.613 95.4996C229.566 95.4611 229.559 95.3915 229.597 95.3442L233.957 89.9801C233.995 89.9326 234.065 89.9255 234.112 89.964C234.16 90.0025 234.167 90.0721 234.128 90.1195L229.768 95.4835C229.747 95.5104 229.715 95.5244 229.683 95.5244Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M237.142 99.5405C237.117 99.5405 237.093 99.5324 237.072 99.5157C237.025 99.4772 237.018 99.4076 237.056 99.3602L241.388 94.0308C241.426 93.9834 241.496 93.9762 241.543 94.0148C241.591 94.0533 241.598 94.1229 241.559 94.1702L237.228 99.4996C237.206 99.5265 237.174 99.5405 237.142 99.5405Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M244.841 101.56C244.816 101.56 244.791 101.552 244.771 101.535C244.724 101.497 244.717 101.427 244.755 101.38L249.044 96.1024C249.083 96.055 249.152 96.0477 249.2 96.0864C249.247 96.1248 249.254 96.1945 249.216 96.2418L244.926 101.519C244.905 101.546 244.873 101.56 244.841 101.56Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M251.655 101.333C251.631 101.333 251.606 101.325 251.586 101.309C251.538 101.27 251.531 101.2 251.57 101.153L255.845 95.8931C255.883 95.8458 255.953 95.8385 256 95.8771C256.047 95.9155 256.055 95.9852 256.016 96.0325L251.741 101.292C251.719 101.319 251.687 101.333 251.655 101.333Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M355.476 156.237C365.481 162.393 381.889 161.321 392.124 153.841C398.203 149.398 400.737 143.693 399.69 138.502L398.787 132.706L398.244 134.747C397.017 132.653 395.116 130.741 392.534 129.153C382.529 122.997 366.121 124.069 355.888 131.549C352.018 134.376 349.585 137.716 348.598 141.108L347.229 139.939L348.173 145.971C348.174 145.98 348.173 145.988 348.175 145.997C348.648 149.877 351.077 153.531 355.476 156.237Z",
    fill: "#FFB22E"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M390.319 144.346L391.847 153.809C387.004 157.286 380.815 159.348 374.584 159.91L372.743 148.514L390.319 144.346Z",
    fill: "#FFBF52"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M373.122 151.232C373.152 151.418 374.133 157.493 374.552 160.087C371.705 160.335 368.851 160.269 366.114 159.882L364.611 150.915L373.122 151.232Z",
    fill: "#FFD269"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M348.175 145.997C348.174 145.988 348.174 145.98 348.173 145.971L347.229 139.939L348.598 141.108C348.708 140.729 348.84 140.35 348.986 139.972L350.11 140.447L357.051 148.632L358.535 157.815C357.463 157.355 356.44 156.83 355.476 156.237C351.077 153.531 348.648 149.877 348.175 145.997Z",
    fill: "#FFE691"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M364.729 150.806L366.197 159.894C363.471 159.515 360.859 158.818 358.486 157.794L356.888 147.903L364.729 150.806Z",
    fill: "#FFE078"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M375.124 152.838C389.381 150.953 399.921 141.722 398.664 132.22C397.408 122.718 384.831 116.544 370.573 118.429C356.316 120.315 345.776 129.546 347.033 139.048C348.289 148.549 360.866 154.724 375.124 152.838Z",
    fill: "#FFD269"
  })), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.719 124.486C356.735 123.013 358.992 121.789 361.392 120.819L359.831 151.668C357.849 151.038 355.987 150.209 354.306 149.175C351.693 147.567 349.777 145.625 348.551 143.5L349.721 129.425C350.97 127.678 352.636 126.008 354.719 124.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.29 120.102L384.749 150.254C381.715 151.532 378.438 152.398 375.116 152.836L379.147 118.259C382.006 118.531 384.766 119.142 387.29 120.102Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask122_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask122_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.439 120.427L394.864 127.685V131.255L350.809 138.417V120.427H393.439Z",
    fill: "#FFE691"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask123_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask123_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 131.82L350.809 138.982V138.417L394.864 131.255V131.82Z",
    fill: "#FFE691"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask124_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask124_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 132.385L350.809 139.547V138.982L394.864 131.82V132.385Z",
    fill: "#FFE590"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask125_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask125_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 132.95L350.809 140.112V139.547L394.864 132.385V132.95Z",
    fill: "#FFE48F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask126_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask126_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 133.515L350.809 140.677V140.112L394.864 132.95V133.515Z",
    fill: "#FFE48E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask127_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask127_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 134.081L350.809 141.242V140.677L394.864 133.515V134.081Z",
    fill: "#FFE38D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask128_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask128_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 134.646L350.809 141.807V141.242L394.864 134.081V134.646Z",
    fill: "#FEE28C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask129_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask129_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 135.211L350.809 142.373V141.808L394.864 134.646V135.211Z",
    fill: "#FEE18B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask130_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask130_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 135.776L350.809 142.938V142.373L394.864 135.211V135.776Z",
    fill: "#FEE08A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask131_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask131_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 136.341L350.809 143.503V142.938L394.864 135.776V136.341Z",
    fill: "#FEE089"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask132_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask132_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 136.906L350.901 144.053L350.809 143.581V143.503L394.864 136.341V136.906Z",
    fill: "#FEDF88"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask133_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask133_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 137.471L351.009 144.601L350.901 144.053L394.864 136.906V137.471Z",
    fill: "#FEDE87"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask134_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask134_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 138.036L351.116 145.148L351.009 144.601L394.864 137.471V138.036Z",
    fill: "#FEDD86"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask135_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask135_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 138.602L351.224 145.696L351.116 145.148L394.864 138.036V138.602Z",
    fill: "#FEDC85"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask136_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask136_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 139.167L351.332 146.243L351.224 145.696L394.864 138.602V139.167Z",
    fill: "#FEDC84"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask137_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask137_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 139.732L351.439 146.791L351.332 146.244L394.864 139.167V139.732Z",
    fill: "#FEDB83"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask138_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask138_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 140.297L351.547 147.339L351.439 146.791L394.864 139.732V140.297Z",
    fill: "#FDDA82"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask139_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask139_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 140.862L351.654 147.886L351.547 147.339L394.864 140.297V140.862Z",
    fill: "#FDD981"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask140_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask140_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 141.427L351.762 148.434L351.654 147.886L394.864 140.862V141.427Z",
    fill: "#FDD880"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask141_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask141_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 141.992L351.869 148.982L351.762 148.434L394.864 141.427V141.992Z",
    fill: "#FDD87F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask142_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask142_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 142.557L351.977 149.529L351.869 148.982L394.864 141.992V142.557Z",
    fill: "#FDD77E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask143_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask143_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 143.123L352.084 150.077L351.977 149.529L394.864 142.557V143.123Z",
    fill: "#FDD67D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask144_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask144_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 143.688L352.192 150.625L352.084 150.077L394.864 143.123V143.688Z",
    fill: "#FDD57C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask145_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask145_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 144.253L354.352 150.838H352.234L352.192 150.624L394.864 143.688V144.253Z",
    fill: "#FDD47B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask146_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask146_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 144.818L357.828 150.838H354.352L394.864 144.253V144.818Z",
    fill: "#FDD47A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask147_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask147_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 145.383L361.304 150.839H357.828L394.864 144.818V145.383Z",
    fill: "#FDD379"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask148_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask148_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 145.948L364.78 150.839H361.304L394.864 145.383V145.948Z",
    fill: "#FCD278"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask149_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask149_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 146.513L368.257 150.838H364.781L394.864 145.948V146.513Z",
    fill: "#FCD177"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask150_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask150_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 147.078L371.733 150.839H368.257L394.864 146.513V147.078Z",
    fill: "#FCD076"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask151_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask151_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 147.644L375.209 150.839H371.733L394.864 147.078V147.644Z",
    fill: "#FCD075"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask152_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask152_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 148.209L378.686 150.839H375.209L394.864 147.644V148.209Z",
    fill: "#FCCF74"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask153_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask153_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 148.774L382.162 150.838H378.686L394.864 148.208V148.774Z",
    fill: "#FCCE72"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask154_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask154_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.864 149.339L385.638 150.839H382.162L394.864 148.774V149.339Z",
    fill: "#FCCD71"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask155_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask155_74_1444)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask156_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask156_74_1444)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask157_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 352,
    y: 122,
    width: 41,
    height: 28
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M374.605 148.915C385.611 147.459 393.747 140.334 392.777 132.999C391.807 125.664 382.098 120.898 371.092 122.353C360.086 123.809 351.95 130.935 352.92 138.269C353.89 145.604 363.599 150.37 374.605 148.915Z",
    fill: "white"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask157_74_1444)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M370.663 149.275C366.192 149.275 361.857 148.261 358.475 146.18C354.905 143.985 352.865 140.887 352.728 137.458C352.578 133.696 354.786 129.862 358.786 126.939C366.706 121.151 379.452 120.319 387.198 125.085C390.767 127.281 392.808 130.379 392.944 133.807C393.094 137.57 390.886 141.404 386.887 144.326C382.425 147.587 376.431 149.275 370.663 149.275ZM375.008 122.208C369.287 122.208 363.343 123.883 358.916 127.118C354.977 129.996 352.802 133.762 352.949 137.45C353.082 140.802 355.086 143.836 358.59 145.992C366.267 150.716 378.902 149.888 386.756 144.148C390.695 141.269 392.87 137.504 392.723 133.816C392.59 130.464 390.586 127.43 387.082 125.273C383.732 123.212 379.437 122.208 375.008 122.208Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M397.636 148.048C397.583 148.048 397.536 148.009 397.527 147.955L396.425 141.131C396.416 141.071 396.456 141.014 396.517 141.004C396.576 140.995 396.634 141.036 396.643 141.096L397.746 147.92C397.755 147.98 397.714 148.037 397.654 148.047C397.648 148.048 397.642 148.048 397.636 148.048Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M391.84 153.969C391.787 153.969 391.74 153.931 391.731 153.877L390.629 147.053C390.619 146.992 390.66 146.936 390.721 146.926C390.78 146.917 390.838 146.957 390.847 147.017L391.95 153.841C391.959 153.902 391.918 153.958 391.858 153.968C391.852 153.969 391.846 153.969 391.84 153.969Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M383.67 158.099C383.616 158.099 383.569 158.06 383.561 158.006L382.466 151.226C382.456 151.166 382.497 151.109 382.557 151.1C382.617 151.091 382.674 151.131 382.684 151.191L383.779 157.971C383.789 158.031 383.748 158.088 383.688 158.098C383.682 158.099 383.676 158.099 383.67 158.099Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M374.598 160.018C374.545 160.018 374.498 159.979 374.49 159.925L373.387 153.101C373.378 153.04 373.419 152.984 373.479 152.974C373.538 152.965 373.596 153.005 373.606 153.066L374.708 159.889C374.717 159.95 374.677 160.006 374.616 160.016C374.61 160.017 374.604 160.018 374.598 160.018Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M366.13 159.776C366.077 159.776 366.03 159.738 366.021 159.684L364.926 152.904C364.916 152.844 364.957 152.787 365.017 152.777C365.076 152.767 365.135 152.808 365.144 152.869L366.239 159.648C366.249 159.709 366.208 159.765 366.148 159.775C366.142 159.776 366.136 159.776 366.13 159.776Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M358.45 157.686C358.397 157.686 358.35 157.647 358.342 157.593L357.257 150.879C357.248 150.819 357.288 150.762 357.349 150.753C357.408 150.744 357.466 150.784 357.475 150.844L358.56 157.558C358.57 157.618 358.529 157.675 358.468 157.684C358.462 157.685 358.456 157.686 358.45 157.686Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M352.658 154.09C352.605 154.09 352.558 154.051 352.549 153.997L351.468 147.305C351.459 147.245 351.499 147.188 351.56 147.179C351.619 147.169 351.677 147.21 351.686 147.27L352.767 153.961C352.777 154.022 352.736 154.078 352.676 154.088C352.67 154.089 352.664 154.09 352.658 154.09Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M375.713 138.287C375.363 138.891 374.923 139.433 374.392 139.912C373.861 140.391 373.268 140.794 372.614 141.121C371.959 141.448 371.245 141.697 370.473 141.867C369.701 142.038 368.902 142.117 368.078 142.104L366.391 144.546C366.357 144.591 366.317 144.634 366.273 144.674C366.229 144.714 366.172 144.746 366.1 144.769C366.029 144.791 365.938 144.807 365.829 144.816C365.72 144.825 365.585 144.824 365.425 144.814C365.24 144.803 365.099 144.784 365.002 144.758C364.904 144.733 364.831 144.705 364.782 144.674C364.733 144.644 364.713 144.603 364.721 144.553C364.73 144.502 364.759 144.448 364.81 144.388L366.503 141.959C366.144 141.889 365.82 141.808 365.533 141.716C365.245 141.623 364.997 141.528 364.788 141.428C364.579 141.329 364.411 141.228 364.283 141.126C364.155 141.024 364.071 140.931 364.033 140.847C363.995 140.762 363.996 140.655 364.038 140.524C364.081 140.394 364.167 140.215 364.298 139.989C364.394 139.823 364.482 139.685 364.562 139.577C364.641 139.468 364.717 139.379 364.791 139.309C364.865 139.24 364.935 139.193 365.003 139.17C365.07 139.147 365.14 139.138 365.212 139.142C365.316 139.149 365.433 139.213 365.563 139.334C365.692 139.456 365.877 139.593 366.117 139.745C366.358 139.897 366.674 140.044 367.066 140.186C367.458 140.328 367.975 140.419 368.617 140.459C369.757 140.531 370.744 140.374 371.579 139.988C372.413 139.602 373.04 139.046 373.46 138.321C373.717 137.876 373.824 137.497 373.78 137.185C373.736 136.873 373.597 136.598 373.365 136.36C373.132 136.123 372.834 135.912 372.47 135.729C372.106 135.546 371.735 135.36 371.357 135.172C370.98 134.984 370.623 134.774 370.287 134.541C369.952 134.309 369.695 134.031 369.516 133.706C369.338 133.382 369.266 132.996 369.301 132.548C369.335 132.1 369.536 131.559 369.903 130.925C370.195 130.419 370.561 129.952 370.999 129.526C371.436 129.1 371.935 128.733 372.494 128.428C373.054 128.123 373.674 127.884 374.356 127.711C375.038 127.539 375.765 127.454 376.538 127.455L378.102 125.182C378.137 125.137 378.176 125.094 378.22 125.054C378.264 125.014 378.323 124.98 378.397 124.953C378.47 124.927 378.558 124.911 378.661 124.905C378.764 124.9 378.9 124.903 379.069 124.913C379.245 124.924 379.387 124.941 379.495 124.964C379.602 124.986 379.677 125.016 379.717 125.054C379.758 125.092 379.773 125.134 379.763 125.18C379.752 125.226 379.73 125.28 379.695 125.34L378.12 127.589C378.347 127.627 378.575 127.683 378.803 127.756C379.031 127.829 379.239 127.908 379.426 127.994C379.613 128.08 379.774 128.173 379.909 128.271C380.043 128.37 380.127 128.451 380.16 128.516C380.193 128.581 380.209 128.64 380.206 128.695C380.204 128.749 380.191 128.811 380.168 128.88C380.144 128.949 380.113 129.029 380.072 129.121C380.032 129.212 379.979 129.315 379.913 129.428C379.83 129.571 379.752 129.696 379.679 129.801C379.606 129.906 379.54 129.988 379.481 130.046C379.422 130.105 379.363 130.149 379.306 130.176C379.248 130.204 379.191 130.216 379.135 130.213C379.047 130.207 378.935 130.149 378.799 130.039C378.663 129.929 378.481 129.808 378.254 129.676C378.027 129.544 377.749 129.417 377.42 129.295C377.092 129.173 376.691 129.097 376.217 129.067C375.679 129.033 375.191 129.053 374.753 129.128C374.315 129.202 373.927 129.32 373.587 129.483C373.248 129.646 372.952 129.848 372.699 130.091C372.447 130.333 372.236 130.602 372.065 130.896C371.803 131.349 371.695 131.734 371.741 132.05C371.787 132.366 371.927 132.641 372.162 132.875C372.397 133.109 372.699 133.315 373.07 133.495C373.44 133.675 373.816 133.861 374.2 134.053C374.584 134.246 374.948 134.454 375.292 134.679C375.635 134.905 375.899 135.179 376.081 135.504C376.263 135.828 376.339 136.215 376.309 136.663C376.278 137.111 376.08 137.652 375.713 138.287Z",
    fill: "#FFBF52"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask158_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask158_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.547 288.272L342.024 323.36H341.547V288.272Z",
    fill: "#7E71DA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask159_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask159_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.11 223.082L344.475 323.36H342.024L341.547 288.272V223.082H343.11Z",
    fill: "#7E72DA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask160_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask160_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.561 223.082L346.925 323.36H344.475L343.11 223.082H345.561Z",
    fill: "#7F73DB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask161_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask161_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.012 223.082L349.376 323.36H346.925L345.561 223.082H348.012Z",
    fill: "#7F74DB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask162_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask162_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.462 223.082L351.827 323.36H349.376L348.012 223.082H350.462Z",
    fill: "#8075DC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask163_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask163_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.913 223.082L354.277 323.36H351.826L350.462 223.082H352.913Z",
    fill: "#8076DC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask164_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask164_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.364 223.082L356.728 323.36H354.277L352.913 223.082H355.364Z",
    fill: "#8177DD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask165_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask165_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.814 223.082L359.178 323.36H356.728L355.364 223.082H357.814Z",
    fill: "#8178DD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask166_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask166_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.265 223.082L361.629 323.36H359.178L357.814 223.082H360.265Z",
    fill: "#8279DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask167_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask167_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.715 223.082L364.08 323.36H361.629L360.265 223.082H362.715Z",
    fill: "#827ADE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask168_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask168_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.166 223.082L366.53 323.36H364.08L362.715 223.082H365.166Z",
    fill: "#837BDF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask169_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask169_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.617 223.082L368.981 323.36H366.53L365.166 223.082H367.617Z",
    fill: "#847CDF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask170_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask170_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.067 223.082L371.432 323.36H368.981L367.617 223.082H370.067Z",
    fill: "#847DE0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask171_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask171_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.518 223.082L373.882 323.36H371.432L370.067 223.082H372.518Z",
    fill: "#857EE0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask172_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask172_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.969 223.082L376.333 323.36H373.882L372.518 223.082H374.969Z",
    fill: "#857FE1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask173_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask173_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.419 223.082L378.784 323.36H376.333L374.969 223.082H377.419Z",
    fill: "#8680E1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask174_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask174_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.87 223.082L381.234 323.36H378.784L377.419 223.082H379.87Z",
    fill: "#8681E2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask175_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask175_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.321 223.082L383.685 323.36H381.234L379.87 223.082H382.321Z",
    fill: "#8782E2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask176_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask176_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.771 223.082L386.136 323.36H383.685L382.321 223.082H384.771Z",
    fill: "#8783E3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask177_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask177_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.222 223.082L388.586 323.36H386.136L384.771 223.082H387.222Z",
    fill: "#8884E3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask178_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask178_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.673 223.082L391.037 323.36H388.586L387.222 223.082H389.673Z",
    fill: "#8885E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask179_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask179_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.123 223.082L393.488 323.36H391.037L389.673 223.082H392.123Z",
    fill: "#8986E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask180_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask180_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.574 223.082L395.938 323.36H393.488L392.123 223.082H394.574Z",
    fill: "#8987E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask181_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask181_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.025 223.082L398.389 323.36H395.938L394.574 223.082H397.025Z",
    fill: "#8A88E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask182_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask182_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.475 223.082L400.84 323.36H398.389L397.025 223.082H399.475Z",
    fill: "#8B89E6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask183_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask183_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.926 223.082L403.29 323.36H400.84L399.475 223.082H401.926Z",
    fill: "#8B8AE6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask184_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask184_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.377 223.082L405.741 323.36H403.29L401.926 223.082H404.377Z",
    fill: "#8C8BE7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask185_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask185_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.827 223.082L408.191 323.36H405.741L404.376 223.082H406.827Z",
    fill: "#8C8CE7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask186_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask186_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.278 223.082L410.642 323.36H408.191L406.827 223.082H409.278Z",
    fill: "#8D8DE8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask187_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask187_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.728 223.082L413.093 323.36H410.642L409.278 223.082H411.728Z",
    fill: "#8D8EE8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask188_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask188_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.179 223.082L415.544 323.36H413.093L411.729 223.082H414.179Z",
    fill: "#8E8FE9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask189_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask189_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.63 223.082L417.994 323.36H415.544L414.179 223.082H416.63Z",
    fill: "#8E90E9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask190_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask190_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.081 223.082L420.445 323.36H417.994L416.63 223.082H419.081Z",
    fill: "#8F91EA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask191_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask191_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.531 223.082L422.895 323.36H420.445L419.081 223.082H421.531Z",
    fill: "#8F92EA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask192_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask192_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.982 223.082L425.346 323.36H422.895L421.531 223.082H423.982Z",
    fill: "#9093EB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask193_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask193_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.432 223.082L427.797 323.36H425.346L423.982 223.082H426.432Z",
    fill: "#9094EB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask194_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask194_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.883 223.082L430.247 323.36H427.797L426.432 223.082H428.883Z",
    fill: "#9196EC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask195_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask195_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.334 223.082L432.698 323.36H430.247L428.883 223.082H431.334Z",
    fill: "#9297EC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask196_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask196_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.784 223.082L435.149 323.36H432.698L431.334 223.082H433.784Z",
    fill: "#9298ED"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask197_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask197_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.235 223.082L437.599 323.36H435.149L433.784 223.082H436.235Z",
    fill: "#9399ED"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask198_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask198_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.686 223.082L440.05 323.36H437.599L436.235 223.082H438.686Z",
    fill: "#939AEE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask199_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask199_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.136 223.082L442.501 323.36H440.05L438.686 223.082H441.136Z",
    fill: "#949BEE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask200_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask200_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.587 223.082L444.951 323.36H442.501L441.136 223.082H443.587Z",
    fill: "#949CEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask201_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask201_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.038 223.082L447.402 323.36H444.951L443.587 223.082H446.038Z",
    fill: "#959DEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask202_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask202_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.488 223.082L449.853 323.36H447.402L446.038 223.082H448.488Z",
    fill: "#959EF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask203_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask203_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.939 223.082L452.303 323.36H449.853L448.488 223.082H450.939Z",
    fill: "#969FF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask204_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask204_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.39 223.082L454.754 323.36H452.303L450.939 223.082H453.39Z",
    fill: "#96A0F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask205_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask205_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.84 223.082L457.205 323.36H454.754L453.39 223.082H455.84Z",
    fill: "#97A1F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask206_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask206_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.291 223.082L459.655 323.36H457.205L455.84 223.082H458.291Z",
    fill: "#97A2F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask207_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask207_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.741 223.082L462.106 323.36H459.655L458.291 223.082H460.741Z",
    fill: "#98A3F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask208_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask208_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.192 223.082L464.556 323.36H462.106L460.741 223.082H463.192Z",
    fill: "#99A4F3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask209_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask209_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.643 223.082L467.007 323.36H464.556L463.192 223.082H465.643Z",
    fill: "#99A5F3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask210_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask210_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.093 223.082L469.458 323.36H467.007L465.643 223.082H468.093Z",
    fill: "#9AA6F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask211_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask211_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.544 223.082L471.909 323.36H469.458L468.094 223.082H470.544Z",
    fill: "#9AA7F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask212_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask212_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.995 223.082L474.359 323.36H471.908L470.544 223.082H472.995Z",
    fill: "#9BA8F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask213_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask213_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.445 223.082L476.81 323.36H474.359L472.995 223.082H475.445Z",
    fill: "#9BA9F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask214_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask214_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.896 223.082L479.26 323.36H476.81L475.445 223.082H477.896Z",
    fill: "#9CAAF6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask215_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask215_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.347 223.082L481.711 323.36H479.26L477.896 223.082H480.347Z",
    fill: "#9CABF6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask216_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask216_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482.797 223.082L484.162 323.36H481.711L480.347 223.082H482.797Z",
    fill: "#9DACF7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask217_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask217_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.248 223.082L486.612 323.36H484.162L482.797 223.082H485.248Z",
    fill: "#9DADF7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask218_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 341,
    y: 223,
    width: 146,
    height: 101
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M351.272 323.36C345.91 323.36 341.547 318.997 341.547 313.634V232.808C341.547 227.445 345.91 223.082 351.272 223.082H477.224C482.587 223.082 486.95 227.445 486.95 232.808V313.634C486.95 318.997 482.587 323.36 477.224 323.36H351.272Z",
    fill: "white"
  }))), _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask218_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.612 323.36L485.248 223.082H486.95V323.36H486.612Z",
    fill: "#9EAEF8"
  }))), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M476.743 225.231C476.743 225.231 353.902 225.231 350.142 225.231C346.381 225.231 345.128 230.603 350.321 230.245C355.514 229.886 476.743 230.245 476.743 230.245C476.743 230.245 482.473 229.349 482.473 237.049C482.473 245.465 482.473 319.958 482.473 319.958C482.473 319.958 485.338 317.451 485.338 313.153C485.338 306.087 485.338 242.066 485.338 237.049C485.338 230.066 483.369 225.231 476.743 225.231Z",
    fill: "#382A73"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M486.542 286.416H443.559C436.569 286.416 430.902 280.749 430.902 273.758C430.902 266.767 436.569 261.1 443.559 261.1H486.542C490.229 261.1 493.217 264.089 493.217 267.776V279.74C493.217 283.427 490.229 286.416 486.542 286.416Z",
    fill: "#5C49D8"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M450.658 280.338C454.402 276.594 454.402 270.524 450.658 266.78C446.914 263.036 440.844 263.036 437.1 266.78C433.356 270.524 433.356 276.594 437.1 280.338C440.844 284.082 446.914 284.082 450.658 280.338Z",
    fill: "#FFC257"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M475.669 235.097H348.351C348.242 235.097 348.154 235.009 348.154 234.9C348.154 234.792 348.243 234.703 348.351 234.703H475.669C475.778 234.703 475.866 234.792 475.866 234.9C475.866 235.009 475.778 235.097 475.669 235.097Z",
    fill: "#FFC257"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M475.669 317.827H348.351C348.242 317.827 348.154 317.739 348.154 317.63C348.154 317.521 348.243 317.433 348.351 317.433H475.669C475.778 317.433 475.866 317.521 475.866 317.63C475.866 317.739 475.778 317.827 475.669 317.827Z",
    fill: "#FFC257"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask219_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask219_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.744 192.228L125.153 222.82H123.744V192.228Z",
    fill: "#8075DC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask220_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask220_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.538 177.634L126.619 222.82H125.153L123.744 192.228V177.634H124.538Z",
    fill: "#8076DC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask221_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask221_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.003 177.634L128.084 222.82H126.619L124.538 177.634H126.003Z",
    fill: "#8177DD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask222_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask222_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.468 177.634L129.549 222.82H128.084L126.003 177.634H127.468Z",
    fill: "#8178DD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask223_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask223_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.934 177.634L131.015 222.82H129.549L127.468 177.634H128.934Z",
    fill: "#8279DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask224_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask224_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.399 177.634L132.48 222.82H131.015L128.934 177.634H130.399Z",
    fill: "#827ADE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask225_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask225_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.865 177.634L133.946 222.82H132.48L130.399 177.634H131.865Z",
    fill: "#837BDF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask226_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask226_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.33 177.634L135.411 222.82H133.945L131.865 177.634H133.33Z",
    fill: "#847CDF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask227_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask227_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.795 177.634L136.876 222.82H135.411L133.33 177.634H134.795Z",
    fill: "#847DE0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask228_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask228_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.261 177.634L138.342 222.82H136.876L134.795 177.634H136.261Z",
    fill: "#857EE0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask229_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask229_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.726 177.634L139.807 222.82H138.342L136.261 177.634H137.726Z",
    fill: "#857FE1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask230_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask230_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.192 177.634L141.272 222.82H139.807L137.726 177.634H139.192Z",
    fill: "#8680E1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask231_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask231_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.657 177.634L142.738 222.82H141.272L139.192 177.634H140.657Z",
    fill: "#8681E2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask232_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask232_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.122 177.634L144.203 222.82H142.738L140.657 177.634H142.122Z",
    fill: "#8782E2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask233_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g235 || (_g235 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask233_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.588 177.634L145.669 222.82H144.203L142.122 177.634H143.588Z",
    fill: "#8783E3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask234_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g236 || (_g236 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask234_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.053 177.634L147.134 222.82H145.669L143.588 177.634H145.053Z",
    fill: "#8884E3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask235_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g237 || (_g237 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask235_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.518 177.634L148.599 222.82H147.134L145.053 177.634H146.518Z",
    fill: "#8885E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask236_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g238 || (_g238 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask236_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.984 177.634L150.065 222.82H148.599L146.518 177.634H147.984Z",
    fill: "#8986E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask237_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g239 || (_g239 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask237_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.449 177.634L151.53 222.82H150.065L147.984 177.634H149.449Z",
    fill: "#8987E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask238_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g240 || (_g240 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask238_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.915 177.634L152.995 222.82H151.53L149.449 177.634H150.915Z",
    fill: "#8A88E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask239_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g241 || (_g241 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask239_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.38 177.634L154.461 222.82H152.995L150.915 177.634H152.38Z",
    fill: "#8B89E6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask240_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g242 || (_g242 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask240_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.845 177.634L155.926 222.82H154.461L152.38 177.634H153.845Z",
    fill: "#8B8AE6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask241_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g243 || (_g243 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask241_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.311 177.634L157.391 222.82H155.926L153.845 177.634H155.311Z",
    fill: "#8C8BE7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask242_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g244 || (_g244 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask242_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.776 177.634L158.857 222.82H157.392L155.311 177.634H156.776Z",
    fill: "#8C8CE7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask243_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g245 || (_g245 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask243_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.241 177.634L160.322 222.82H158.857L156.776 177.634H158.241Z",
    fill: "#8D8DE8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask244_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g246 || (_g246 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask244_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.707 177.634L161.788 222.82H160.322L158.241 177.634H159.707Z",
    fill: "#8D8EE8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask245_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g247 || (_g247 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask245_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.172 177.634L163.253 222.82H161.788L159.707 177.634H161.172Z",
    fill: "#8E8FE9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask246_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g248 || (_g248 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask246_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.637 177.634L164.718 222.82H163.253L161.172 177.634H162.637Z",
    fill: "#8E90E9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask247_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g249 || (_g249 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask247_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.103 177.634L166.184 222.82H164.719L162.638 177.634H164.103Z",
    fill: "#8F91EA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask248_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g250 || (_g250 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask248_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.568 177.634L167.649 222.82H166.184L164.103 177.634H165.568Z",
    fill: "#8F92EA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask249_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g251 || (_g251 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask249_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.034 177.634L169.115 222.82H167.649L165.568 177.634H167.034Z",
    fill: "#9093EB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask250_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g252 || (_g252 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask250_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.499 177.634L170.58 222.82H169.115L167.034 177.634H168.499Z",
    fill: "#9094EB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask251_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g253 || (_g253 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask251_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.965 177.634L172.045 222.82H170.58L168.499 177.634H169.965Z",
    fill: "#9196EC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask252_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g254 || (_g254 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask252_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.43 177.634L173.511 222.82H172.045L169.964 177.634H171.43Z",
    fill: "#9297EC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask253_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g255 || (_g255 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask253_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.895 177.634L174.976 222.82H173.511L171.43 177.634H172.895Z",
    fill: "#9298ED"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask254_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g256 || (_g256 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask254_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.361 177.634L176.442 222.82H174.976L172.895 177.634H174.361Z",
    fill: "#9399ED"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask255_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g257 || (_g257 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask255_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.826 177.634L177.907 222.82H176.441L174.361 177.634H175.826Z",
    fill: "#939AEE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask256_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g258 || (_g258 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask256_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.291 177.634L179.372 222.82H177.907L175.826 177.634H177.291Z",
    fill: "#949BEE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask257_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g259 || (_g259 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask257_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.757 177.634L180.838 222.82H179.372L177.291 177.634H178.757Z",
    fill: "#949CEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask258_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g260 || (_g260 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask258_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.222 177.634L182.303 222.82H180.838L178.757 177.634H180.222Z",
    fill: "#959DEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask259_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g261 || (_g261 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask259_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.688 177.634L183.768 222.82H182.303L180.222 177.634H181.688Z",
    fill: "#959EF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask260_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g262 || (_g262 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask260_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.153 177.634L185.234 222.82H183.768L181.688 177.634H183.153Z",
    fill: "#969FF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask261_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g263 || (_g263 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask261_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.618 177.634L186.699 222.82H185.234L183.153 177.634H184.618Z",
    fill: "#96A0F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask262_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g264 || (_g264 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask262_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.084 177.634L188.165 222.82H186.699L184.618 177.634H186.084Z",
    fill: "#97A1F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask263_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g265 || (_g265 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask263_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.549 177.634L189.63 222.82H188.164L186.084 177.634H187.549Z",
    fill: "#97A2F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask264_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g266 || (_g266 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask264_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.014 177.634L191.095 222.82H189.63L187.549 177.634H189.014Z",
    fill: "#98A3F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask265_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g267 || (_g267 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask265_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.48 177.634L192.561 222.82H191.095L189.014 177.634H190.48Z",
    fill: "#99A4F3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask266_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g268 || (_g268 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask266_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.945 177.634L194.026 222.82H192.561L190.48 177.634H191.945Z",
    fill: "#99A5F3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask267_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g269 || (_g269 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask267_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.41 177.634L195.491 222.82H194.026L191.945 177.634H193.41Z",
    fill: "#9AA6F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask268_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g270 || (_g270 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask268_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.876 177.634L196.957 222.82H195.491L193.411 177.634H194.876Z",
    fill: "#9AA7F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask269_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g271 || (_g271 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask269_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.341 177.634L198.422 222.82H196.957L194.876 177.634H196.341Z",
    fill: "#9BA8F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask270_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g272 || (_g272 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask270_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.807 177.634L199.888 222.82H198.422L196.341 177.634H197.807Z",
    fill: "#9BA9F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask271_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g273 || (_g273 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask271_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.272 177.634L201.353 222.82H199.888L197.807 177.634H199.272Z",
    fill: "#9CAAF6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask272_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g274 || (_g274 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask272_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.737 177.634L202.818 222.82H201.353L199.272 177.634H200.737Z",
    fill: "#9CABF6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask273_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g275 || (_g275 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask273_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.203 177.634L204.284 222.82H202.818L200.737 177.634H202.203Z",
    fill: "#9DACF7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask274_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g276 || (_g276 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask274_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.668 177.634L205.749 222.82H204.284L202.203 177.634H203.668Z",
    fill: "#9DADF7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask275_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g277 || (_g277 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask275_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.134 177.634L206.22 201.228V222.82H205.749L203.668 177.634H205.134Z",
    fill: "#9EAEF8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask276_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 177,
    width: 83,
    height: 46
  }, _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M203.276 222.81L133.86 222.448C132.108 222.439 130.462 221.013 130.182 219.264L124.024 180.795C123.744 179.045 124.937 177.634 126.688 177.643L196.105 178.006C197.856 178.015 199.503 179.441 199.783 181.19L205.94 219.659C206.22 221.409 205.028 222.82 203.276 222.81Z",
    fill: "white"
  }))), _g278 || (_g278 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask276_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.22 201.228L205.134 177.634H206.22V201.228Z",
    fill: "#9EAFF8"
  }))), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M142.194 195.792L135.562 195.757C134.506 195.752 133.513 194.892 133.344 193.838L132.585 189.093C132.416 188.038 133.135 187.188 134.191 187.193L140.823 187.228C141.879 187.233 142.871 188.093 143.04 189.148L143.8 193.892C143.968 194.947 143.25 195.798 142.194 195.792Z",
    fill: "#F2CB05"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M135.682 196.51C134.213 196.503 132.826 195.302 132.591 193.834L131.832 189.089C131.597 187.621 132.601 186.433 134.07 186.441L140.703 186.475C142.172 186.483 143.559 187.684 143.794 189.152L144.553 193.896C144.788 195.364 143.784 196.553 142.315 196.545L135.682 196.51Z",
    fill: "#FFC257"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M142.204 195.888C142.2 195.888 142.197 195.888 142.194 195.888L135.561 195.854C134.462 195.848 133.425 194.95 133.25 193.853L132.49 189.109C132.403 188.566 132.536 188.057 132.863 187.675C133.182 187.302 133.65 187.097 134.181 187.097C134.184 187.097 134.188 187.097 134.191 187.097L140.824 187.132C141.923 187.138 142.96 188.035 143.135 189.133L143.895 193.877C143.982 194.42 143.849 194.929 143.522 195.31C143.203 195.683 142.735 195.888 142.204 195.888ZM142.194 195.696C142.671 195.706 143.092 195.517 143.376 195.185C143.666 194.847 143.783 194.394 143.705 193.908L142.945 189.163C142.784 188.155 141.832 187.33 140.823 187.325L134.19 187.29C134.187 187.29 134.184 187.29 134.181 187.29C133.707 187.29 133.291 187.471 133.008 187.801C132.719 188.139 132.602 188.592 132.68 189.078L133.439 193.823C133.601 194.831 134.553 195.656 135.562 195.662L142.194 195.696Z",
    fill: "#5C49D8"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M137.795 195.865C137.766 195.865 137.738 195.853 137.719 195.829L136.398 194.165C136.173 193.882 136.025 193.555 135.971 193.219L135.418 189.761C135.365 189.43 135.406 189.106 135.536 188.824L136.257 187.259C136.28 187.211 136.336 187.19 136.385 187.212C136.433 187.234 136.454 187.291 136.432 187.339L135.71 188.905C135.596 189.152 135.561 189.437 135.608 189.731L136.161 193.189C136.21 193.492 136.344 193.788 136.548 194.046L137.87 195.71C137.903 195.751 137.896 195.812 137.855 195.845C137.837 195.859 137.816 195.865 137.795 195.865Z",
    fill: "#5C49D8"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M139.961 195.877C139.947 195.877 139.933 195.874 139.919 195.868C139.871 195.845 139.851 195.787 139.874 195.739L140.665 194.086C140.785 193.835 140.823 193.544 140.775 193.244L140.222 189.786C140.174 189.49 140.045 189.2 139.848 188.946L138.623 187.37C138.591 187.328 138.598 187.268 138.64 187.235C138.682 187.203 138.742 187.21 138.775 187.252L140 188.828C140.217 189.107 140.359 189.428 140.412 189.756L140.965 193.214C141.019 193.552 140.975 193.883 140.838 194.169L140.048 195.822C140.031 195.857 139.997 195.877 139.961 195.877Z",
    fill: "#5C49D8"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M143.35 191.475C143.35 191.475 143.35 191.475 143.35 191.475L140.618 191.461C140.565 191.461 140.522 191.417 140.522 191.364C140.523 191.311 140.566 191.269 140.619 191.269C140.619 191.269 140.619 191.269 140.619 191.269L143.351 191.283C143.404 191.283 143.447 191.326 143.447 191.379C143.446 191.432 143.403 191.475 143.35 191.475Z",
    fill: "#5C49D8"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M135.768 191.435C135.768 191.435 135.767 191.435 135.767 191.435L133.036 191.421C132.983 191.421 132.94 191.378 132.94 191.324C132.94 191.271 132.984 191.229 133.036 191.229C133.037 191.229 133.037 191.229 133.037 191.229L135.768 191.243C135.822 191.243 135.864 191.286 135.864 191.34C135.864 191.393 135.821 191.435 135.768 191.435Z",
    fill: "#5C49D8"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M178.583 217.012C178.579 217.012 178.575 217.012 178.572 217.012L138.711 216.804C137.604 216.798 136.56 215.895 136.383 214.79C136.296 214.243 136.429 213.731 136.758 213.347C137.08 212.971 137.551 212.765 138.085 212.765C138.089 212.765 138.092 212.765 138.096 212.765L177.957 212.973C179.063 212.979 180.107 213.882 180.284 214.987C180.372 215.534 180.239 216.046 179.909 216.431C179.588 216.806 179.117 217.012 178.583 217.012ZM138.085 212.957C137.608 212.957 137.189 213.14 136.904 213.472C136.612 213.812 136.495 214.27 136.573 214.759C136.736 215.775 137.695 216.607 138.712 216.612L178.573 216.82C178.576 216.82 178.579 216.82 178.583 216.82C179.06 216.82 179.479 216.637 179.764 216.305C180.055 215.965 180.173 215.508 180.094 215.018C179.932 214.002 178.972 213.171 177.956 213.165L138.095 212.957C138.092 212.957 138.088 212.957 138.085 212.957Z",
    fill: "white"
  })), _g279 || (_g279 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.912 206.493L137.027 206.186C135.714 206.179 134.479 205.11 134.269 203.797L134.015 202.213C133.805 200.901 134.699 199.843 136.013 199.85L194.898 200.157C196.212 200.164 197.446 201.233 197.657 202.545L197.91 204.129C198.12 205.442 197.226 206.5 195.912 206.493Z",
    fill: "white"
  }))), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M198.587 218.376H187.555C186.501 218.376 185.504 217.521 185.33 216.466L184.863 213.638C184.688 212.583 185.402 211.728 186.456 211.728H197.488C198.543 211.728 199.539 212.583 199.713 213.638L200.18 216.466C200.355 217.521 199.641 218.376 198.587 218.376Z",
    fill: "#FFC257"
  })), _g280 || (_g280 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.988 177.739L130.07 218.566L130.182 219.264C130.462 221.013 132.108 222.439 133.859 222.448L146.506 222.514L162.833 177.832L144.988 177.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.349 184.727L186.465 222.723L193.126 222.757L202.381 197.427L200.349 184.727Z",
    fill: "white"
  }))), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M160.833 163.686C157.587 163.686 154.52 161.038 153.982 157.772L146.94 114.977C146.403 111.71 148.598 109.062 151.844 109.062C155.09 109.062 158.157 111.71 158.695 114.977L165.737 157.772C166.274 161.038 164.079 163.686 160.833 163.686Z",
    fill: "#382A73"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask277_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 103,
    width: 52,
    height: 60
  }, _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M173.608 103.033L147.714 113.567L147.092 116.017L153.931 157.528L161.21 161.185L173.059 162.502L198.076 143.301L192.37 110.494L173.608 103.033Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask277_74_1444)"
  }, _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M183.451 152.701C193.47 142.681 193.47 126.436 183.451 116.417C173.431 106.397 157.186 106.397 147.167 116.417C137.147 126.436 137.147 142.681 147.167 152.701C157.186 162.72 173.431 162.72 183.451 152.701Z",
    fill: "#FFD269"
  })), _g281 || (_g281 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.81 137.395C191.119 134.621 190.971 131.9 190.43 129.308L155.748 158.372C157.854 159.217 160.108 159.795 162.474 160.058C166.151 160.467 169.733 160.076 173.047 159.026L188.554 145.439C189.712 142.964 190.491 140.261 190.81 137.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.283 110.167L140.09 139.3C140.714 142.625 141.986 145.748 143.783 148.517L181.072 114.311C178.772 112.517 176.148 111.1 173.283 110.167Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask278_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g282 || (_g282 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask278_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.204 148.72L177.857 153.623L154.77 114.317L155.879 113.665H186.204V148.72Z",
    fill: "#FFE691"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask279_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 115,
    width: 41,
    height: 40
  }, _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M184.771 139.817C187.523 129.23 181.172 118.417 170.585 115.665C159.998 112.913 149.185 119.265 146.433 129.852C143.681 140.438 150.032 151.252 160.619 154.003C171.206 156.755 182.019 150.404 184.771 139.817Z",
    fill: "white"
  }))), _g283 || (_g283 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask279_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.78 114.315L154.069 114.733L177.158 154.04L177.869 153.623L154.78 114.315Z",
    fill: "#FFE691"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask280_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M184.461 139.518C187.213 128.931 180.862 118.118 170.275 115.366C159.688 112.614 148.875 118.966 146.123 129.553C143.371 140.139 149.723 150.953 160.309 153.704C170.896 156.456 181.709 150.105 184.461 139.518Z",
    fill: "white"
  }))), _g284 || (_g284 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask280_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.069 114.736L153.358 115.154L176.447 154.461L177.157 154.044L154.069 114.736Z",
    fill: "#FFE590"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask281_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 40,
    height: 41
  }, _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M184.152 139.212C186.904 128.626 180.553 117.812 169.966 115.06C159.379 112.309 148.566 118.66 145.814 129.247C143.062 139.834 149.414 150.647 160.001 153.399C170.587 156.151 181.401 149.799 184.152 139.212Z",
    fill: "white"
  }))), _g285 || (_g285 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask281_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.359 115.15L152.648 115.568L175.736 154.875L176.447 154.458L153.359 115.15Z",
    fill: "#FFE48F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask282_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 114,
    width: 41,
    height: 40
  }, _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M183.843 138.91C186.595 128.323 180.244 117.51 169.657 114.758C159.07 112.006 148.257 118.358 145.505 128.944C142.753 139.531 149.104 150.344 159.691 153.096C170.278 155.848 181.091 149.497 183.843 138.91Z",
    fill: "white"
  }))), _g286 || (_g286 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask282_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.648 115.568L151.937 115.985L175.026 155.293L175.736 154.875L152.648 115.568Z",
    fill: "#FFE48E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask283_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g287 || (_g287 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask283_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.014 155.292L174.742 155.452H174.152L151.216 116.404L151.927 115.987L175.014 155.292Z",
    fill: "#FFE38D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask284_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g288 || (_g288 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask284_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.196 155.452L150.505 116.821L151.216 116.404L174.152 155.452H173.196Z",
    fill: "#FEE28C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask285_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g289 || (_g289 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask285_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.24 155.452L149.795 117.239L150.505 116.822L173.196 155.452H172.24Z",
    fill: "#FEE18B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask286_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g290 || (_g290 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask286_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.284 155.452L149.084 117.656L149.795 117.239L172.24 155.452H171.284Z",
    fill: "#FEE08A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask287_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g291 || (_g291 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask287_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.328 155.452L148.373 118.074L149.084 117.656L171.284 155.452H170.328Z",
    fill: "#FEE089"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask288_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g292 || (_g292 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask288_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.372 155.452L147.663 118.491L148.373 118.074L170.328 155.452H169.372Z",
    fill: "#FEDF88"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask289_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g293 || (_g293 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask289_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.416 155.452L146.952 118.909L147.663 118.491L169.372 155.452H168.416Z",
    fill: "#FEDE87"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask290_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g294 || (_g294 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask290_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.46 155.452L146.241 119.326L146.952 118.909L168.416 155.452H167.46Z",
    fill: "#FEDD86"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask291_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g295 || (_g295 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask291_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.505 155.452L145.531 119.744L146.241 119.326L167.46 155.452H166.505Z",
    fill: "#FEDC85"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask292_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g296 || (_g296 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask292_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.549 155.452L144.82 120.161L145.531 119.744L166.505 155.452H165.549Z",
    fill: "#FEDC84"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask293_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g297 || (_g297 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask293_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.593 155.452L144.417 121.103V120.398L144.82 120.161L165.549 155.452H164.593Z",
    fill: "#FEDB83"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask294_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g298 || (_g298 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask294_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.637 155.452L144.417 122.731V121.103L164.593 155.452H163.637Z",
    fill: "#FDDA82"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask295_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g299 || (_g299 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask295_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.681 155.452L144.417 124.358V122.731L163.637 155.452H162.681Z",
    fill: "#FDD981"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask296_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g300 || (_g300 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask296_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.725 155.452L144.417 125.985V124.358L162.681 155.452H161.725Z",
    fill: "#FDD880"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask297_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g301 || (_g301 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask297_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.769 155.452L144.417 127.613V125.985L161.725 155.452H160.769Z",
    fill: "#FDD87F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask298_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g302 || (_g302 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask298_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.813 155.452L144.417 129.24V127.613L160.769 155.452H159.813Z",
    fill: "#FDD77E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask299_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g303 || (_g303 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask299_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.857 155.452L144.417 130.868V129.24L159.813 155.452H158.857Z",
    fill: "#FDD67D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask300_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g304 || (_g304 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask300_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.901 155.452L144.417 132.495V130.868L158.857 155.452H157.901Z",
    fill: "#FDD57C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask301_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g305 || (_g305 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask301_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.946 155.452L144.417 134.122V132.495L157.901 155.452H156.946Z",
    fill: "#FDD47B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask302_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g306 || (_g306 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask302_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.99 155.452L144.417 135.75V134.122L156.946 155.452H155.99Z",
    fill: "#FDD47A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask303_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g307 || (_g307 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask303_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.034 155.452L144.417 137.377V135.75L155.99 155.452H155.034Z",
    fill: "#FDD379"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask304_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g308 || (_g308 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask304_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.078 155.452L144.417 139.005V137.377L155.034 155.452H154.078Z",
    fill: "#FCD278"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask305_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g309 || (_g309 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask305_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.122 155.452L144.417 140.632V139.005L154.078 155.452H153.122Z",
    fill: "#FCD177"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask306_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g310 || (_g310 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask306_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.166 155.452L144.417 142.259V140.632L153.122 155.452H152.166Z",
    fill: "#FCD076"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask307_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g311 || (_g311 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask307_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.21 155.452L144.417 143.887V142.259L152.166 155.452H151.21Z",
    fill: "#FCD075"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask308_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g312 || (_g312 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask308_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.254 155.452L144.417 145.514V143.887L151.21 155.452H150.254Z",
    fill: "#FCCF74"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask309_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g313 || (_g313 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask309_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.298 155.452L144.417 147.142V145.514L150.254 155.452H149.298Z",
    fill: "#FCCE72"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask310_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g314 || (_g314 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask310_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.343 155.452L144.417 148.769V147.142L149.298 155.452H148.343Z",
    fill: "#FCCD71"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask311_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g315 || (_g315 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask311_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.387 155.452L144.417 150.396V148.769L148.343 155.452H147.387Z",
    fill: "#FCCD70"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask312_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 114,
    width: 41,
    height: 41
  }, _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M179.313 148.563C187.047 140.829 187.047 128.289 179.313 120.555C171.579 112.82 159.039 112.82 151.304 120.554C143.57 128.289 143.57 140.829 151.304 148.563C159.039 156.298 171.579 156.298 179.313 148.563Z",
    fill: "white"
  }))), _g316 || (_g316 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask312_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.431 155.452L144.417 152.024V150.396L147.387 155.452H146.431Z",
    fill: "#FCCC6F"
  }))), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M165.326 154.497C164.592 154.497 163.852 154.456 163.106 154.373C152.18 153.158 144.281 143.28 145.496 132.354C146.712 121.428 156.589 113.528 167.515 114.744C178.441 115.96 186.341 125.837 185.125 136.763C183.993 146.943 175.339 154.497 165.326 154.497ZM165.273 114.882C160.827 114.882 156.545 116.377 153.023 119.194C148.919 122.476 146.339 127.16 145.757 132.383C144.558 143.165 152.354 152.912 163.135 154.112C168.357 154.693 173.495 153.205 177.599 149.923C181.703 146.641 184.283 141.957 184.864 136.734C185.445 131.511 183.957 126.375 180.675 122.271C177.393 118.167 172.709 115.586 167.486 115.005C166.746 114.923 166.007 114.882 165.273 114.882Z",
    fill: "white"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M172.254 138.852C172.199 139.718 171.985 140.496 171.61 141.185C171.235 141.873 170.728 142.453 170.09 142.924C169.451 143.396 168.684 143.755 167.787 144.003C166.891 144.252 165.899 144.369 164.813 144.355L164.234 147.858C164.219 147.922 164.196 147.984 164.165 148.041C164.135 148.099 164.08 148.145 164.002 148.178C163.924 148.211 163.816 148.234 163.679 148.248C163.542 148.261 163.366 148.26 163.149 148.247C162.9 148.231 162.703 148.205 162.559 148.169C162.414 148.133 162.3 148.093 162.216 148.05C162.131 148.006 162.078 147.949 162.055 147.876C162.033 147.804 162.035 147.726 162.062 147.64L162.656 144.154C162.14 144.057 161.663 143.943 161.226 143.812C160.788 143.681 160.399 143.545 160.06 143.404C159.721 143.263 159.434 143.12 159.198 142.975C158.963 142.83 158.792 142.697 158.685 142.576C158.579 142.455 158.509 142.301 158.478 142.114C158.446 141.927 158.44 141.671 158.46 141.347C158.475 141.108 158.498 140.911 158.53 140.756C158.562 140.6 158.602 140.472 158.652 140.372C158.702 140.272 158.763 140.205 158.836 140.171C158.909 140.138 158.994 140.124 159.091 140.13C159.232 140.139 159.428 140.23 159.678 140.403C159.928 140.577 160.261 140.772 160.677 140.988C161.093 141.204 161.604 141.413 162.212 141.614C162.819 141.816 163.556 141.943 164.422 141.998C165.96 142.094 167.146 141.864 167.981 141.308C168.815 140.751 169.265 139.953 169.33 138.913C169.37 138.274 169.257 137.731 168.992 137.285C168.726 136.839 168.362 136.446 167.899 136.107C167.437 135.768 166.906 135.469 166.308 135.208C165.71 134.948 165.101 134.684 164.482 134.417C163.863 134.149 163.256 133.85 162.662 133.52C162.069 133.189 161.547 132.792 161.098 132.328C160.648 131.866 160.297 131.313 160.044 130.672C159.79 130.031 159.692 129.255 159.749 128.345C159.795 127.62 159.962 126.951 160.25 126.338C160.539 125.725 160.947 125.199 161.475 124.759C162.003 124.319 162.655 123.974 163.432 123.724C164.209 123.474 165.103 123.347 166.115 123.346L166.645 120.084C166.66 120.02 166.683 119.959 166.714 119.901C166.745 119.843 166.799 119.795 166.878 119.756C166.956 119.718 167.061 119.694 167.192 119.686C167.323 119.678 167.503 119.681 167.73 119.695C167.968 119.71 168.165 119.733 168.321 119.765C168.476 119.797 168.594 119.839 168.672 119.893C168.75 119.947 168.798 120.007 168.816 120.073C168.833 120.14 168.839 120.216 168.834 120.303L168.272 123.53C168.595 123.583 168.93 123.661 169.277 123.764C169.624 123.868 169.949 123.98 170.251 124.103C170.553 124.225 170.825 124.356 171.066 124.496C171.307 124.637 171.471 124.753 171.558 124.845C171.645 124.938 171.705 125.023 171.738 125.101C171.771 125.179 171.795 125.268 171.811 125.367C171.826 125.466 171.838 125.581 171.846 125.712C171.854 125.843 171.853 125.989 171.843 126.152C171.83 126.358 171.811 126.536 171.785 126.686C171.76 126.837 171.728 126.955 171.69 127.039C171.652 127.124 171.604 127.186 171.547 127.226C171.49 127.266 171.424 127.284 171.348 127.279C171.229 127.271 171.044 127.189 170.793 127.032C170.542 126.875 170.224 126.703 169.838 126.515C169.453 126.328 169.005 126.148 168.494 125.974C167.983 125.801 167.408 125.694 166.769 125.654C166.043 125.608 165.418 125.64 164.895 125.749C164.372 125.857 163.942 126.029 163.607 126.263C163.271 126.498 163.019 126.789 162.851 127.137C162.682 127.485 162.584 127.871 162.558 128.293C162.517 128.943 162.632 129.494 162.903 129.946C163.173 130.398 163.54 130.791 164.003 131.124C164.466 131.458 165 131.753 165.604 132.008C166.207 132.263 166.824 132.528 167.454 132.801C168.084 133.074 168.699 133.371 169.299 133.691C169.898 134.012 170.426 134.404 170.88 134.867C171.335 135.331 171.692 135.883 171.951 136.525C172.21 137.166 172.311 137.942 172.254 138.852Z",
    fill: "#FFBF52"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask313_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g317 || (_g317 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask313_74_1444)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask314_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g318 || (_g318 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask314_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.329 241.102L144.473 260.089H143.52L143.376 241.102H144.329Z",
    fill: "#7C6ED8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask315_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g319 || (_g319 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask315_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.281 241.102L145.425 260.089H144.473L144.329 241.102H145.281Z",
    fill: "#7D6FD9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask316_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g320 || (_g320 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask316_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.234 241.102L146.377 260.089H145.425L145.281 241.102H146.234Z",
    fill: "#7D70D9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask317_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g321 || (_g321 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask317_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.186 241.102L147.33 260.089H146.377L146.234 241.102H147.186Z",
    fill: "#7E71DA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask318_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g322 || (_g322 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask318_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.138 241.102L148.282 260.089H147.33L147.186 241.102H148.138Z",
    fill: "#7E72DA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask319_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g323 || (_g323 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask319_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.091 241.102L149.235 260.089H148.282L148.138 241.102H149.091Z",
    fill: "#7F73DB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask320_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g324 || (_g324 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask320_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.043 241.102L150.187 260.089H149.235L149.091 241.102H150.043Z",
    fill: "#7F74DB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask321_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g325 || (_g325 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask321_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.996 241.102L151.139 260.089H150.187L150.043 241.102H150.996Z",
    fill: "#8075DC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask322_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g326 || (_g326 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask322_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.948 241.102L152.092 260.089H151.139L150.996 241.102H151.948Z",
    fill: "#8076DC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask323_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g327 || (_g327 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask323_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.9 241.102L153.044 260.089H152.092L151.948 241.102H152.9Z",
    fill: "#8177DD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask324_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g328 || (_g328 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask324_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.853 241.102L153.997 260.089H153.044L152.9 241.102H153.853Z",
    fill: "#8178DD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask325_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g329 || (_g329 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask325_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.805 241.102L154.949 260.089H153.997L153.853 241.102H154.805Z",
    fill: "#8279DE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask326_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g330 || (_g330 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask326_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.758 241.102L155.901 260.089H154.949L154.805 241.102H155.758Z",
    fill: "#827ADE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask327_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g331 || (_g331 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask327_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.71 241.102L156.854 260.089H155.901L155.758 241.102H156.71Z",
    fill: "#837BDF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask328_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g332 || (_g332 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask328_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.662 241.102L157.806 260.089H156.854L156.71 241.102H157.662Z",
    fill: "#847CDF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask329_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g333 || (_g333 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask329_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.615 241.102L158.759 260.089H157.806L157.662 241.102H158.615Z",
    fill: "#847DE0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask330_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g334 || (_g334 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask330_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.567 241.102L159.711 260.089H158.759L158.615 241.102H159.567Z",
    fill: "#857EE0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask331_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g335 || (_g335 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask331_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.52 241.102L160.663 260.089H159.711L159.567 241.102H160.52Z",
    fill: "#857FE1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask332_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g336 || (_g336 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask332_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.472 241.102L161.616 260.089H160.663L160.52 241.102H161.472Z",
    fill: "#8680E1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask333_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g337 || (_g337 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask333_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.425 241.102L162.568 260.089H161.616L161.472 241.102H162.425Z",
    fill: "#8681E2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask334_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g338 || (_g338 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask334_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.377 241.102L163.521 260.089H162.568L162.424 241.102H163.377Z",
    fill: "#8782E2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask335_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g339 || (_g339 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask335_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.329 241.102L164.473 260.089H163.521L163.377 241.102H164.329Z",
    fill: "#8783E3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask336_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g340 || (_g340 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask336_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.282 241.102L165.426 260.089H164.473L164.329 241.102H165.282Z",
    fill: "#8884E3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask337_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g341 || (_g341 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask337_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.234 241.102L166.378 260.089H165.426L165.282 241.102H166.234Z",
    fill: "#8885E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask338_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g342 || (_g342 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask338_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.187 241.102L167.33 260.089H166.378L166.234 241.102H167.187Z",
    fill: "#8986E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask339_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g343 || (_g343 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask339_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.139 241.102L168.283 260.089H167.33L167.187 241.102H168.139Z",
    fill: "#8987E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask340_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g344 || (_g344 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask340_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.091 241.102L169.235 260.089H168.283L168.139 241.102H169.091Z",
    fill: "#8A88E5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask341_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g345 || (_g345 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask341_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.044 241.102L170.188 260.089H169.235L169.091 241.102H170.044Z",
    fill: "#8B89E6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask342_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g346 || (_g346 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask342_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.996 241.102L171.14 260.089H170.188L170.044 241.102H170.996Z",
    fill: "#8B8AE6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask343_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g347 || (_g347 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask343_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.949 241.102L172.092 260.089H171.14L170.996 241.102H171.949Z",
    fill: "#8C8BE7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask344_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g348 || (_g348 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask344_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.901 241.102L173.045 260.089H172.092L171.949 241.102H172.901Z",
    fill: "#8C8CE7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask345_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g349 || (_g349 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask345_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.853 241.102L173.997 260.089H173.045L172.901 241.102H173.853Z",
    fill: "#8D8DE8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask346_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g350 || (_g350 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask346_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.806 241.102L174.95 260.089H173.997L173.854 241.102H174.806Z",
    fill: "#8D8EE8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask347_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g351 || (_g351 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask347_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.758 241.102L175.902 260.089H174.95L174.806 241.102H175.758Z",
    fill: "#8E8FE9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask348_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g352 || (_g352 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask348_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.711 241.102L176.855 260.089H175.902L175.758 241.102H176.711Z",
    fill: "#8E90E9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask349_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g353 || (_g353 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask349_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.663 241.102L177.807 260.089H176.855L176.711 241.102H177.663Z",
    fill: "#8F91EA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask350_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g354 || (_g354 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask350_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.616 241.102L178.759 260.089H177.807L177.663 241.102H178.616Z",
    fill: "#8F92EA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask351_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g355 || (_g355 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask351_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.568 241.102L179.712 260.089H178.759L178.615 241.102H179.568Z",
    fill: "#9093EB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask352_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g356 || (_g356 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask352_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.52 241.102L180.664 260.089H179.712L179.568 241.102H180.52Z",
    fill: "#9094EB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask353_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g357 || (_g357 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask353_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.473 241.102L181.617 260.089H180.664L180.52 241.102H181.473Z",
    fill: "#9196EC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask354_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g358 || (_g358 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask354_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.425 241.102L182.569 260.089H181.617L181.473 241.102H182.425Z",
    fill: "#9297EC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask355_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g359 || (_g359 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask355_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.378 241.102L183.521 260.089H182.569L182.425 241.102H183.378Z",
    fill: "#9298ED"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask356_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g360 || (_g360 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask356_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.33 241.102L184.474 260.089H183.521L183.378 241.102H184.33Z",
    fill: "#9399ED"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask357_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g361 || (_g361 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask357_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.282 241.102L185.426 260.089H184.474L184.33 241.102H185.282Z",
    fill: "#939AEE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask358_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g362 || (_g362 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask358_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.235 241.102L186.379 260.089H185.426L185.282 241.102H186.235Z",
    fill: "#949BEE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask359_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g363 || (_g363 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask359_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.187 241.102L187.331 260.089H186.379L186.235 241.102H187.187Z",
    fill: "#949CEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask360_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g364 || (_g364 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask360_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.14 241.102L188.283 260.089H187.331L187.187 241.102H188.14Z",
    fill: "#959DEF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask361_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g365 || (_g365 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask361_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.092 241.102L189.236 260.089H188.283L188.14 241.102H189.092Z",
    fill: "#959EF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask362_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g366 || (_g366 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask362_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.045 241.102L190.188 260.089H189.236L189.092 241.102H190.045Z",
    fill: "#969FF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask363_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g367 || (_g367 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask363_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.997 241.102L191.141 260.089H190.188L190.045 241.102H190.997Z",
    fill: "#96A0F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask364_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g368 || (_g368 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask364_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.949 241.102L192.093 260.089H191.141L190.997 241.102H191.949Z",
    fill: "#97A1F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask365_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g369 || (_g369 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask365_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.902 241.102L193.046 260.089H192.093L191.949 241.102H192.902Z",
    fill: "#97A2F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask366_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g370 || (_g370 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask366_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.854 241.102L193.998 260.089H193.046L192.902 241.102H193.854Z",
    fill: "#98A3F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask367_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g371 || (_g371 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask367_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.807 241.102L194.95 260.089H193.998L193.854 241.102H194.807Z",
    fill: "#99A4F3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask368_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g372 || (_g372 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask368_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.759 241.102L195.903 260.089H194.95L194.807 241.102H195.759Z",
    fill: "#99A5F3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask369_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g373 || (_g373 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask369_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.711 241.102L196.855 260.089H195.903L195.759 241.102H196.711Z",
    fill: "#9AA6F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask370_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g374 || (_g374 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask370_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.664 241.102L197.808 260.089H196.855L196.711 241.102H197.664Z",
    fill: "#9AA7F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask371_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g375 || (_g375 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask371_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.616 241.102L198.76 260.089H197.808L197.664 241.102H198.616Z",
    fill: "#9BA8F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask372_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g376 || (_g376 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask372_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.569 241.102L199.712 260.089H198.76L198.616 241.102H199.569Z",
    fill: "#9BA9F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask373_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g377 || (_g377 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask373_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.521 241.102L200.665 260.089H199.712L199.568 241.102H200.521Z",
    fill: "#9CAAF6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask374_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g378 || (_g378 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask374_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.473 241.102L201.617 260.089H200.665L200.521 241.102H201.473Z",
    fill: "#9CABF6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask375_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g379 || (_g379 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask375_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.426 241.102L202.57 260.089H201.617L201.473 241.102H202.426Z",
    fill: "#9DACF7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask376_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g380 || (_g380 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask376_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.378 241.102L203.522 260.089H202.57L202.426 241.102H203.378Z",
    fill: "#9DADF7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask377_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g381 || (_g381 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask377_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.331 241.102L204.474 260.089H203.522L203.378 241.102H204.331Z",
    fill: "#9EAEF8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask378_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g382 || (_g382 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask378_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.283 241.102L205.427 260.089H204.474L204.331 241.102H205.283Z",
    fill: "#9EAFF8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask379_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g383 || (_g383 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask379_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.235 241.102L206.379 260.089H205.427L205.283 241.102H206.235Z",
    fill: "#9FB0F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask380_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g384 || (_g384 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask380_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.188 241.102L207.332 260.089H206.379L206.235 241.102H207.188Z",
    fill: "#A0B1F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask381_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 241,
    width: 63,
    height: 20
  }, _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M155.326 260.088H198.634C203.928 260.088 207.526 255.838 206.67 250.595C205.813 245.352 200.827 241.102 195.532 241.102H152.225C146.93 241.102 143.332 245.352 144.188 250.595C145.045 255.838 150.032 260.088 155.326 260.088Z",
    fill: "white"
  }))), _g385 || (_g385 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask381_74_1444)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M159.624 252.772C159.634 252.823 159.641 252.867 159.645 252.905C159.649 252.943 159.65 252.976 159.648 253.004C159.645 253.033 159.64 253.058 159.631 253.08C159.623 253.102 159.605 253.129 159.58 253.161C159.554 253.192 159.496 253.24 159.407 253.305C159.317 253.37 159.203 253.433 159.063 253.494C158.924 253.556 158.76 253.608 158.572 253.651C158.385 253.693 158.175 253.715 157.942 253.715C157.54 253.715 157.165 253.648 156.816 253.516C156.467 253.383 156.153 253.187 155.875 252.929C155.597 252.67 155.36 252.35 155.164 251.97C154.968 251.59 154.822 251.152 154.727 250.656C154.629 250.148 154.607 249.695 154.663 249.298C154.718 248.9 154.839 248.563 155.025 248.287C155.21 248.011 155.456 247.8 155.761 247.655C156.066 247.51 156.421 247.437 156.825 247.437C157.004 247.437 157.181 247.454 157.356 247.487C157.531 247.52 157.696 247.562 157.849 247.612C158.002 247.663 158.141 247.721 158.265 247.788C158.39 247.854 158.477 247.908 158.529 247.951C158.58 247.993 158.614 248.026 158.631 248.048C158.648 248.07 158.663 248.096 158.677 248.126C158.691 248.156 158.704 248.192 158.717 248.233C158.73 248.274 158.741 248.322 158.752 248.379C158.764 248.443 158.772 248.496 158.774 248.54C158.776 248.584 158.774 248.622 158.766 248.651C158.759 248.681 158.748 248.704 158.734 248.718C158.719 248.732 158.698 248.739 158.673 248.739C158.628 248.739 158.559 248.708 158.468 248.647C158.375 248.585 158.259 248.517 158.118 248.443C157.977 248.369 157.81 248.301 157.617 248.24C157.425 248.178 157.201 248.147 156.948 248.147C156.673 248.147 156.433 248.202 156.228 248.311C156.023 248.419 155.861 248.58 155.741 248.791C155.622 249.003 155.548 249.26 155.518 249.565C155.489 249.87 155.512 250.218 155.587 250.609C155.662 250.997 155.771 251.34 155.914 251.639C156.056 251.937 156.226 252.186 156.423 252.386C156.621 252.587 156.845 252.738 157.095 252.841C157.346 252.944 157.617 252.995 157.908 252.995C158.155 252.995 158.365 252.965 158.537 252.905C158.71 252.845 158.854 252.778 158.969 252.704C159.085 252.629 159.178 252.563 159.25 252.503C159.322 252.443 159.382 252.413 159.43 252.413C159.452 252.413 159.473 252.417 159.49 252.427C159.508 252.436 159.524 252.454 159.539 252.481C159.554 252.508 159.569 252.545 159.582 252.592C159.596 252.64 159.61 252.7 159.624 252.772Z",
    fill: "white"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M165.459 253.35C165.497 253.419 165.522 253.475 165.532 253.518C165.541 253.56 165.536 253.593 165.514 253.615C165.493 253.637 165.454 253.651 165.396 253.658C165.338 253.664 165.26 253.667 165.161 253.667C165.062 253.667 164.983 253.665 164.923 253.66C164.863 253.655 164.817 253.647 164.785 253.636C164.752 253.625 164.727 253.61 164.709 253.591C164.691 253.572 164.673 253.549 164.655 253.52L163.836 252.029H161.264L161.042 253.501C161.038 253.53 161.029 253.554 161.018 253.575C161.005 253.595 160.986 253.613 160.958 253.627C160.931 253.641 160.89 253.651 160.835 253.658C160.781 253.664 160.709 253.667 160.619 253.667C160.527 253.667 160.451 253.663 160.39 253.655C160.329 253.647 160.285 253.632 160.257 253.61C160.229 253.588 160.211 253.556 160.205 253.513C160.198 253.471 160.201 253.415 160.213 253.345L161.189 247.655C161.195 247.62 161.206 247.592 161.223 247.57C161.239 247.548 161.266 247.53 161.304 247.518C161.341 247.505 161.39 247.496 161.452 247.492C161.513 247.487 161.591 247.485 161.687 247.485C161.789 247.485 161.874 247.487 161.942 247.492C162.01 247.496 162.065 247.505 162.109 247.518C162.153 247.53 162.189 247.549 162.216 247.572C162.242 247.596 162.265 247.625 162.285 247.66L165.459 253.35ZM161.826 248.327H161.821L161.344 251.38H163.496L161.826 248.327Z",
    fill: "white"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M169.538 251.92C169.593 252.207 169.589 252.463 169.526 252.687C169.462 252.911 169.351 253.101 169.191 253.257C169.032 253.414 168.831 253.531 168.59 253.61C168.349 253.689 168.08 253.729 167.783 253.729C167.576 253.729 167.381 253.711 167.197 253.677C167.014 253.642 166.848 253.599 166.699 253.548C166.551 253.498 166.424 253.446 166.32 253.392C166.216 253.339 166.142 253.293 166.098 253.255C166.054 253.217 166.017 253.169 165.989 253.111C165.96 253.052 165.936 252.974 165.917 252.876C165.904 252.807 165.896 252.749 165.893 252.704C165.891 252.658 165.893 252.621 165.9 252.592C165.908 252.564 165.92 252.544 165.937 252.533C165.954 252.522 165.975 252.517 166.001 252.517C166.045 252.517 166.113 252.543 166.205 252.597C166.297 252.651 166.412 252.709 166.552 252.772C166.692 252.835 166.857 252.895 167.047 252.95C167.238 253.005 167.451 253.033 167.687 253.033C167.866 253.033 168.025 253.009 168.164 252.962C168.303 252.914 168.417 252.847 168.507 252.76C168.597 252.674 168.659 252.567 168.692 252.441C168.725 252.315 168.726 252.171 168.695 252.01C168.661 251.837 168.592 251.688 168.489 251.565C168.386 251.442 168.26 251.334 168.111 251.241C167.962 251.148 167.797 251.062 167.615 250.985C167.432 250.908 167.246 250.829 167.055 250.748C166.864 250.668 166.676 250.579 166.492 250.481C166.307 250.384 166.137 250.268 165.98 250.135C165.824 250.003 165.688 249.848 165.572 249.669C165.457 249.491 165.375 249.277 165.327 249.028C165.277 248.772 165.28 248.544 165.336 248.344C165.391 248.143 165.489 247.975 165.63 247.84C165.771 247.704 165.951 247.601 166.168 247.53C166.385 247.458 166.628 247.423 166.896 247.423C167.033 247.423 167.173 247.435 167.316 247.458C167.459 247.482 167.596 247.514 167.726 247.553C167.857 247.593 167.974 247.637 168.079 247.686C168.184 247.735 168.255 247.774 168.291 247.804C168.327 247.834 168.352 247.858 168.365 247.875C168.378 247.893 168.39 247.915 168.401 247.941C168.413 247.968 168.424 248 168.434 248.038C168.445 248.076 168.456 248.125 168.468 248.185C168.479 248.242 168.486 248.293 168.49 248.337C168.493 248.381 168.493 248.418 168.49 248.448C168.486 248.478 168.476 248.5 168.462 248.514C168.447 248.528 168.428 248.536 168.406 248.536C168.371 248.536 168.312 248.514 168.228 248.469C168.145 248.425 168.044 248.376 167.925 248.32C167.806 248.265 167.668 248.215 167.511 248.169C167.354 248.123 167.183 248.1 166.998 248.1C166.826 248.1 166.68 248.123 166.562 248.169C166.443 248.214 166.35 248.275 166.281 248.351C166.213 248.427 166.168 248.517 166.147 248.621C166.126 248.725 166.126 248.836 166.149 248.952C166.182 249.123 166.25 249.269 166.353 249.392C166.457 249.515 166.584 249.624 166.734 249.719C166.885 249.814 167.052 249.901 167.237 249.979C167.421 250.058 167.608 250.138 167.799 250.218C167.99 250.299 168.179 250.387 168.366 250.484C168.554 250.58 168.727 250.694 168.884 250.824C169.042 250.955 169.178 251.11 169.294 251.289C169.41 251.467 169.491 251.677 169.538 251.92Z",
    fill: "white"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M175.477 253.515C175.482 253.541 175.48 253.563 175.471 253.582C175.462 253.601 175.443 253.616 175.413 253.627C175.383 253.638 175.343 253.647 175.292 253.655C175.241 253.663 175.177 253.667 175.101 253.667C175.018 253.667 174.95 253.663 174.897 253.655C174.845 253.647 174.802 253.638 174.768 253.627C174.734 253.616 174.708 253.601 174.692 253.582C174.676 253.563 174.665 253.541 174.66 253.515L174.135 250.798H171.32L171.844 253.515C171.849 253.541 171.847 253.563 171.838 253.582C171.829 253.601 171.809 253.616 171.78 253.627C171.75 253.638 171.71 253.647 171.658 253.655C171.607 253.663 171.542 253.667 171.462 253.667C171.386 253.667 171.32 253.663 171.264 253.655C171.208 253.647 171.163 253.638 171.13 253.627C171.096 253.616 171.07 253.601 171.054 253.582C171.037 253.563 171.027 253.541 171.022 253.515L169.887 247.636C169.882 247.611 169.884 247.589 169.893 247.57C169.902 247.551 169.922 247.536 169.951 247.525C169.981 247.514 170.022 247.504 170.075 247.496C170.128 247.488 170.192 247.484 170.269 247.484C170.348 247.484 170.415 247.488 170.469 247.496C170.523 247.504 170.567 247.514 170.601 247.525C170.635 247.536 170.661 247.551 170.677 247.57C170.693 247.589 170.704 247.611 170.709 247.636L171.183 250.088H173.998L173.525 247.636C173.52 247.611 173.522 247.589 173.531 247.57C173.54 247.551 173.56 247.536 173.589 247.525C173.619 247.514 173.659 247.504 173.708 247.496C173.758 247.488 173.824 247.484 173.907 247.484C173.983 247.484 174.048 247.488 174.103 247.496C174.157 247.504 174.201 247.514 174.235 247.525C174.269 247.536 174.294 247.551 174.311 247.57C174.327 247.589 174.338 247.611 174.343 247.636L175.477 253.515Z",
    fill: "white"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M180.885 251.882C180.922 252.075 180.931 252.253 180.913 252.415C180.895 252.577 180.854 252.724 180.79 252.853C180.726 252.982 180.64 253.096 180.533 253.194C180.426 253.292 180.3 253.374 180.155 253.44C180.01 253.506 179.851 253.556 179.677 253.589C179.503 253.622 179.3 253.639 179.068 253.639H177.452C177.379 253.639 177.304 253.614 177.23 253.565C177.155 253.516 177.106 253.43 177.082 253.307L176.027 247.844C176.003 247.721 176.019 247.635 176.075 247.586C176.131 247.537 176.196 247.513 176.269 247.513H177.674C178.044 247.513 178.354 247.548 178.603 247.617C178.852 247.687 179.068 247.788 179.252 247.92C179.435 248.053 179.585 248.215 179.702 248.408C179.819 248.6 179.901 248.818 179.948 249.061C179.976 249.206 179.985 249.345 179.976 249.478C179.966 249.61 179.938 249.733 179.891 249.844C179.844 249.956 179.777 250.057 179.691 250.145C179.604 250.234 179.5 250.306 179.377 250.363C179.552 250.394 179.721 250.452 179.883 250.535C180.046 250.619 180.195 250.726 180.33 250.855C180.465 250.985 180.581 251.136 180.678 251.31C180.776 251.483 180.845 251.674 180.885 251.882ZM179.117 249.142C179.089 248.993 179.042 248.859 178.977 248.739C178.913 248.619 178.828 248.517 178.723 248.434C178.618 248.35 178.489 248.286 178.338 248.242C178.186 248.198 177.993 248.176 177.757 248.176H176.908L177.291 250.159H178.226C178.439 250.159 178.606 250.132 178.725 250.077C178.845 250.021 178.939 249.947 179.007 249.854C179.075 249.761 179.116 249.652 179.132 249.527C179.148 249.403 179.143 249.274 179.117 249.142ZM180.029 251.93C179.993 251.747 179.933 251.586 179.847 251.447C179.761 251.308 179.653 251.191 179.522 251.097C179.39 251.002 179.235 250.93 179.055 250.881C178.876 250.832 178.657 250.808 178.4 250.808H177.417L177.834 252.966H179.026C179.214 252.966 179.374 252.945 179.505 252.9C179.636 252.856 179.747 252.791 179.837 252.704C179.927 252.617 179.989 252.509 180.025 252.38C180.06 252.25 180.062 252.1 180.029 251.93Z",
    fill: "white"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M186.953 253.35C186.992 253.419 187.016 253.475 187.026 253.518C187.036 253.56 187.03 253.593 187.009 253.615C186.987 253.637 186.948 253.651 186.89 253.658C186.832 253.664 186.754 253.667 186.655 253.667C186.557 253.667 186.477 253.665 186.417 253.66C186.357 253.655 186.311 253.647 186.279 253.636C186.247 253.625 186.221 253.61 186.203 253.591C186.185 253.572 186.167 253.549 186.149 253.52L185.331 252.029H182.758L182.536 253.501C182.532 253.53 182.524 253.554 182.512 253.575C182.5 253.595 182.48 253.613 182.453 253.627C182.425 253.641 182.384 253.651 182.329 253.658C182.275 253.664 182.203 253.667 182.114 253.667C182.021 253.667 181.945 253.663 181.884 253.655C181.824 253.647 181.78 253.632 181.751 253.61C181.723 253.588 181.706 253.556 181.699 253.513C181.692 253.471 181.695 253.415 181.707 253.345L182.683 247.655C182.689 247.62 182.701 247.592 182.717 247.57C182.734 247.548 182.76 247.53 182.798 247.518C182.835 247.505 182.885 247.496 182.946 247.492C183.007 247.487 183.086 247.485 183.181 247.485C183.283 247.485 183.368 247.487 183.436 247.492C183.504 247.496 183.56 247.505 183.604 247.518C183.647 247.53 183.683 247.549 183.71 247.572C183.737 247.596 183.76 247.625 183.779 247.66L186.953 253.35ZM183.32 248.327H183.315L182.839 251.38H184.99L183.32 248.327Z",
    fill: "white"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M191.933 252.772C191.943 252.823 191.949 252.867 191.953 252.905C191.958 252.943 191.958 252.976 191.956 253.004C191.954 253.033 191.948 253.058 191.94 253.08C191.931 253.102 191.914 253.129 191.888 253.161C191.862 253.192 191.805 253.24 191.715 253.305C191.626 253.37 191.511 253.433 191.372 253.494C191.232 253.556 191.069 253.608 190.881 253.651C190.693 253.693 190.483 253.715 190.25 253.715C189.849 253.715 189.473 253.648 189.124 253.516C188.775 253.383 188.461 253.187 188.184 252.929C187.906 252.67 187.669 252.35 187.473 251.97C187.277 251.59 187.131 251.152 187.035 250.656C186.937 250.148 186.916 249.695 186.971 249.298C187.027 248.9 187.147 248.563 187.333 248.287C187.519 248.011 187.764 247.8 188.069 247.655C188.374 247.51 188.729 247.437 189.134 247.437C189.312 247.437 189.489 247.454 189.664 247.487C189.84 247.52 190.004 247.562 190.157 247.612C190.31 247.663 190.449 247.721 190.574 247.788C190.698 247.854 190.786 247.908 190.837 247.951C190.888 247.993 190.922 248.026 190.939 248.048C190.956 248.07 190.972 248.096 190.985 248.126C190.999 248.156 191.012 248.192 191.025 248.233C191.038 248.274 191.05 248.322 191.061 248.379C191.073 248.443 191.08 248.496 191.082 248.54C191.084 248.584 191.082 248.622 191.075 248.651C191.068 248.681 191.057 248.704 191.042 248.718C191.027 248.732 191.007 248.739 190.981 248.739C190.936 248.739 190.868 248.708 190.776 248.647C190.684 248.585 190.567 248.517 190.426 248.443C190.286 248.369 190.119 248.301 189.926 248.24C189.733 248.178 189.51 248.147 189.257 248.147C188.981 248.147 188.741 248.202 188.536 248.311C188.331 248.419 188.169 248.58 188.05 248.791C187.93 249.003 187.856 249.26 187.827 249.565C187.797 249.87 187.82 250.218 187.896 250.609C187.971 250.997 188.08 251.34 188.222 251.639C188.365 251.937 188.534 252.186 188.732 252.386C188.929 252.587 189.153 252.738 189.404 252.841C189.654 252.944 189.925 252.995 190.217 252.995C190.463 252.995 190.673 252.965 190.846 252.905C191.018 252.845 191.162 252.778 191.278 252.704C191.393 252.629 191.487 252.563 191.559 252.503C191.63 252.443 191.69 252.413 191.738 252.413C191.761 252.413 191.781 252.417 191.799 252.427C191.817 252.436 191.833 252.454 191.848 252.481C191.862 252.508 191.877 252.545 191.891 252.592C191.905 252.64 191.919 252.7 191.933 252.772Z",
    fill: "white"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M197.199 253.506C197.204 253.531 197.203 253.554 197.196 253.575C197.189 253.595 197.17 253.612 197.141 253.624C197.111 253.637 197.071 253.647 197.018 253.655C196.965 253.663 196.896 253.667 196.81 253.667C196.698 253.667 196.606 253.662 196.535 253.653C196.463 253.643 196.407 253.626 196.367 253.601C196.327 253.575 196.293 253.547 196.264 253.515L193.397 250.453L193.989 253.515C193.993 253.538 193.991 253.559 193.982 253.579C193.973 253.6 193.954 253.616 193.924 253.627C193.894 253.638 193.854 253.647 193.803 253.655C193.752 253.663 193.686 253.667 193.607 253.667C193.53 253.667 193.464 253.663 193.409 253.655C193.353 253.647 193.308 253.638 193.274 253.627C193.24 253.616 193.215 253.6 193.198 253.579C193.181 253.559 193.171 253.538 193.166 253.515L192.031 247.636C192.026 247.611 192.029 247.589 192.038 247.57C192.047 247.551 192.066 247.536 192.096 247.525C192.126 247.514 192.167 247.504 192.219 247.496C192.272 247.488 192.337 247.484 192.413 247.484C192.493 247.484 192.56 247.488 192.614 247.496C192.668 247.504 192.712 247.514 192.746 247.525C192.78 247.536 192.805 247.551 192.822 247.57C192.838 247.589 192.849 247.611 192.854 247.636L193.379 250.358L195.043 247.636C195.057 247.608 195.074 247.584 195.096 247.565C195.118 247.546 195.146 247.531 195.181 247.52C195.215 247.509 195.258 247.5 195.31 247.494C195.361 247.488 195.428 247.484 195.511 247.484C195.594 247.484 195.662 247.488 195.714 247.496C195.767 247.504 195.809 247.514 195.842 247.527C195.875 247.54 195.899 247.555 195.913 247.574C195.928 247.593 195.938 247.614 195.942 247.636C195.95 247.677 195.947 247.718 195.935 247.759C195.922 247.8 195.894 247.857 195.85 247.929L194.269 250.358L197.038 253.265C197.108 253.347 197.152 253.403 197.169 253.433C197.186 253.463 197.196 253.487 197.199 253.506Z",
    fill: "white"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M320.12 68.7443L324.598 59.9025C324.787 59.5284 325.244 59.3787 325.618 59.5681L333.853 63.7382C334.227 63.9277 334.377 64.3845 334.187 64.7586L329.71 73.6004L320.12 68.7443Z",
    fill: "#FFB22E"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M324.876 83.1206L329.697 73.6018L320.107 68.7453L315.287 78.2642L324.876 83.1206Z",
    fill: "#FFBF52"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M320.049 92.6533L324.87 83.1345L315.28 78.2781L310.46 87.7969L320.049 92.6533Z",
    fill: "#FFD269"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M315.222 102.186L320.043 92.6675L310.453 87.811L305.633 97.3298L315.222 102.186Z",
    fill: "#FFE078"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M301.154 106.198L305.631 97.3564L315.221 102.213L310.743 111.054C310.554 111.429 310.097 111.578 309.723 111.389L301.488 107.219C301.114 107.029 300.964 106.572 301.154 106.198Z",
    fill: "#FFE691"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M329.129 73.4592C329.108 73.4592 329.086 73.4543 329.066 73.4441L320.595 69.1545C320.526 69.1196 320.499 69.0355 320.534 68.9665C320.569 68.8976 320.652 68.8695 320.722 68.9051L329.192 73.1947C329.262 73.2296 329.289 73.3137 329.254 73.3826C329.229 73.4312 329.18 73.4592 329.129 73.4592Z",
    fill: "white"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M324.302 82.9919C324.28 82.9919 324.259 82.987 324.239 82.9768L315.768 78.6872C315.699 78.6523 315.672 78.5682 315.706 78.4992C315.741 78.4304 315.825 78.4022 315.894 78.4378L324.365 82.7274C324.434 82.7623 324.462 82.8463 324.427 82.9153C324.402 82.9639 324.353 82.9919 324.302 82.9919Z",
    fill: "white"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M319.474 92.5249C319.453 92.5249 319.432 92.5201 319.411 92.5098L310.94 88.2203C310.871 88.1854 310.844 88.1013 310.879 88.0323C310.914 87.9636 310.998 87.9355 311.067 87.9709L319.538 92.2604C319.607 92.2953 319.634 92.3794 319.599 92.4483C319.574 92.4969 319.525 92.5249 319.474 92.5249Z",
    fill: "white"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M314.647 102.058C314.626 102.058 314.604 102.053 314.584 102.043L306.113 97.753C306.044 97.7181 306.016 97.6341 306.051 97.5651C306.086 97.4961 306.17 97.4683 306.239 97.5036L314.71 101.793C314.779 101.828 314.807 101.912 314.772 101.981C314.747 102.03 314.698 102.058 314.647 102.058Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask382_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 378,
    y: 179,
    width: 67,
    height: 52
  }, _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M397.319 179.179L378.886 206.171L387.883 230.09H435.282L444.718 202.66L429.577 180.935L397.319 179.179Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask382_74_1444)"
  }, _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M429.272 234.047C439.291 224.027 439.291 207.782 429.272 197.763C419.252 187.743 403.007 187.743 392.988 197.763C382.968 207.782 382.968 224.027 392.988 234.047C403.007 244.066 419.252 244.066 429.272 234.047Z",
    fill: "#FFD269"
  })), _g386 || (_g386 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.633 218.741C436.942 215.966 436.794 213.246 436.253 210.654L401.571 239.717C403.678 240.562 405.931 241.14 408.297 241.403C411.975 241.812 415.556 241.421 418.87 240.371L434.377 226.784C435.535 224.309 436.315 221.607 436.633 218.741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.106 191.512L385.913 220.645C386.537 223.97 387.809 227.093 389.606 229.862L426.896 195.656C424.595 193.862 421.971 192.445 419.106 191.512Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask383_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g387 || (_g387 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask383_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.027 230.065L423.68 234.968L400.593 195.662L401.703 195.01H432.027V230.065Z",
    fill: "#FFE691"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask384_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 41,
    height: 40
  }, _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M430.605 221.159C433.357 210.572 427.006 199.759 416.419 197.007C405.832 194.255 395.019 200.606 392.267 211.193C389.515 221.78 395.867 232.593 406.454 235.345C417.04 238.097 427.854 231.745 430.605 221.159Z",
    fill: "white"
  }))), _g388 || (_g388 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask384_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.616 195.655L399.905 196.072L422.994 235.38L423.704 234.962L400.616 195.655Z",
    fill: "#FFE691"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask385_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M430.296 220.856C433.048 210.27 426.697 199.456 416.11 196.705C405.523 193.953 394.71 200.304 391.958 210.891C389.206 221.478 395.557 232.291 406.144 235.043C416.731 237.795 427.544 231.443 430.296 220.856Z",
    fill: "white"
  }))), _g389 || (_g389 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask385_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.905 196.073L399.195 196.49L422.283 235.797L422.994 235.38L399.905 196.073Z",
    fill: "#FFE590"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask386_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 195,
    width: 40,
    height: 41
  }, _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M429.987 220.561C432.739 209.974 426.387 199.161 415.801 196.409C405.214 193.657 394.401 200.009 391.649 210.596C388.897 221.183 395.248 231.996 405.835 234.748C416.422 237.5 427.235 231.148 429.987 220.561Z",
    fill: "white"
  }))), _g390 || (_g390 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask386_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.195 196.497L398.484 196.915L421.573 236.222L422.283 235.805L399.195 196.497Z",
    fill: "#FFE48F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask387_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 390,
    y: 195,
    width: 41,
    height: 41
  }, _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M429.677 220.251C432.429 209.665 426.078 198.851 415.491 196.1C404.904 193.348 394.091 199.699 391.339 210.286C388.587 220.873 394.939 231.686 405.526 234.438C416.112 237.19 426.926 230.838 429.677 220.251Z",
    fill: "white"
  }))), _g391 || (_g391 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask387_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.484 196.907L397.773 197.325L420.862 236.632L421.572 236.215L398.484 196.907Z",
    fill: "#FFE48E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask388_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g392 || (_g392 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask388_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.837 236.637L420.566 236.797H419.975L397.04 197.749L397.75 197.332L420.837 236.637Z",
    fill: "#FFE38D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask389_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g393 || (_g393 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask389_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.019 236.797L396.329 198.167L397.04 197.749L419.975 236.797H419.019Z",
    fill: "#FEE28C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask390_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g394 || (_g394 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask390_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.063 236.797L395.618 198.584L396.329 198.167L419.019 236.797H418.063Z",
    fill: "#FEE18B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask391_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g395 || (_g395 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask391_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.107 236.797L394.907 199.002L395.618 198.584L418.063 236.797H417.107Z",
    fill: "#FEE08A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask392_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g396 || (_g396 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask392_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.151 236.797L394.197 199.419L394.907 199.002L417.107 236.797H416.151Z",
    fill: "#FEE089"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask393_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g397 || (_g397 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask393_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.196 236.797L393.486 199.836L394.197 199.419L416.151 236.797H415.196Z",
    fill: "#FEDF88"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask394_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g398 || (_g398 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask394_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.24 236.797L392.775 200.254L393.486 199.836L415.196 236.797H414.24Z",
    fill: "#FEDE87"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask395_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g399 || (_g399 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask395_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.284 236.797L392.065 200.671L392.775 200.254L414.24 236.797H413.284Z",
    fill: "#FEDD86"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask396_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g400 || (_g400 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask396_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.328 236.797L391.354 201.089L392.065 200.671L413.284 236.797H412.328Z",
    fill: "#FEDC85"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask397_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g401 || (_g401 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask397_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.372 236.797L390.643 201.506L391.354 201.089L412.328 236.797H411.372Z",
    fill: "#FEDC84"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask398_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g402 || (_g402 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask398_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.416 236.797L390.241 202.448V201.743L390.643 201.506L411.372 236.797H410.416Z",
    fill: "#FEDB83"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask399_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g403 || (_g403 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask399_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.46 236.797L390.241 204.076V202.448L410.416 236.797H409.46Z",
    fill: "#FDDA82"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask400_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g404 || (_g404 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask400_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.504 236.797L390.241 205.703V204.076L409.46 236.797H408.504Z",
    fill: "#FDD981"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask401_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g405 || (_g405 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask401_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.548 236.797L390.241 207.331V205.703L408.504 236.797H407.548Z",
    fill: "#FDD880"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask402_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g406 || (_g406 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask402_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.593 236.797L390.241 208.958V207.331L407.548 236.797H406.593Z",
    fill: "#FDD87F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask403_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g407 || (_g407 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask403_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.637 236.797L390.241 210.585V208.958L406.593 236.797H405.637Z",
    fill: "#FDD77E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask404_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g408 || (_g408 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask404_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.681 236.797L390.241 212.213V210.585L405.637 236.797H404.681Z",
    fill: "#FDD67D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask405_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g409 || (_g409 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask405_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.725 236.797L390.241 213.84V212.213L404.681 236.797H403.725Z",
    fill: "#FDD57C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask406_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g410 || (_g410 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask406_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.769 236.797L390.241 215.467V213.84L403.725 236.797H402.769Z",
    fill: "#FDD47B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask407_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g411 || (_g411 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask407_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.813 236.797L390.241 217.095V215.468L402.769 236.797H401.813Z",
    fill: "#FDD47A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask408_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g412 || (_g412 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask408_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.857 236.797L390.241 218.722V217.095L401.813 236.797H400.857Z",
    fill: "#FDD379"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask409_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g413 || (_g413 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask409_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.901 236.797L390.241 220.35V218.722L400.857 236.797H399.901Z",
    fill: "#FCD278"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask410_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g414 || (_g414 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask410_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.945 236.797L390.241 221.977V220.35L399.901 236.797H398.945Z",
    fill: "#FCD177"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask411_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g415 || (_g415 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask411_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.99 236.797L390.241 223.604V221.977L398.945 236.797H397.99Z",
    fill: "#FCD076"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask412_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g416 || (_g416 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask412_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.034 236.797L390.241 225.232V223.604L397.99 236.797H397.034Z",
    fill: "#FCD075"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask413_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g417 || (_g417 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask413_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.078 236.797L390.241 226.859V225.232L397.034 236.797H396.078Z",
    fill: "#FCCF74"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask414_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g418 || (_g418 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask414_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.122 236.797L390.241 228.487V226.859L396.078 236.797H395.122Z",
    fill: "#FCCE72"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask415_74_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 391,
    y: 196,
    width: 40,
    height: 40
  }, _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M425.134 229.909C432.869 222.175 432.869 209.635 425.134 201.901C417.4 194.166 404.86 194.166 397.125 201.901C389.391 209.635 389.391 222.175 397.125 229.909C404.86 237.644 417.4 237.644 425.134 229.909Z",
    fill: "white"
  }))), _g419 || (_g419 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask415_74_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.166 236.797L390.241 230.114V228.487L395.122 236.797H394.166Z",
    fill: "#FCCD71"
  }))), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M411.173 235.843C410.429 235.843 409.68 235.801 408.93 235.718C403.637 235.129 398.89 232.515 395.564 228.356C392.238 224.197 390.731 218.992 391.32 213.699C391.908 208.406 394.523 203.66 398.682 200.334C402.841 197.008 408.046 195.5 413.339 196.089C418.631 196.678 423.378 199.293 426.704 203.451C430.03 207.61 431.537 212.815 430.949 218.108C430.36 223.401 427.745 228.147 423.586 231.473C420.017 234.328 415.677 235.843 411.173 235.843ZM411.096 196.227C406.651 196.227 402.368 197.722 398.846 200.539C394.742 203.821 392.162 208.505 391.581 213.728C391 218.951 392.487 224.088 395.77 228.191C399.052 232.296 403.736 234.876 408.959 235.457C414.181 236.038 419.318 234.55 423.422 231.268C427.526 227.986 430.106 223.302 430.687 218.079C431.268 212.856 429.781 207.72 426.499 203.616C423.216 199.512 418.532 196.931 413.31 196.35C412.569 196.268 411.83 196.227 411.096 196.227Z",
    fill: "white"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M418.077 220.197C418.023 221.064 417.808 221.841 417.433 222.53C417.058 223.219 416.551 223.798 415.913 224.269C415.274 224.741 414.507 225.1 413.611 225.348C412.714 225.597 411.723 225.714 410.636 225.7L410.058 229.203C410.043 229.268 410.02 229.329 409.989 229.387C409.958 229.444 409.904 229.49 409.826 229.523C409.747 229.556 409.64 229.579 409.503 229.593C409.366 229.606 409.189 229.605 408.973 229.592C408.724 229.576 408.527 229.55 408.383 229.514C408.238 229.478 408.123 229.438 408.039 229.395C407.955 229.351 407.901 229.294 407.879 229.221C407.856 229.149 407.858 229.071 407.886 228.985L408.479 225.499C407.964 225.402 407.487 225.288 407.049 225.157C406.611 225.026 406.223 224.89 405.884 224.749C405.545 224.608 405.257 224.465 405.022 224.32C404.786 224.175 404.615 224.042 404.509 223.921C404.402 223.8 404.333 223.646 404.301 223.459C404.269 223.272 404.264 223.016 404.284 222.692C404.299 222.453 404.322 222.256 404.354 222.101C404.385 221.945 404.426 221.817 404.476 221.717C404.525 221.617 404.586 221.55 404.659 221.516C404.732 221.483 404.817 221.469 404.915 221.475C405.055 221.484 405.251 221.575 405.501 221.748C405.751 221.922 406.084 222.117 406.5 222.333C406.916 222.549 407.428 222.758 408.035 222.959C408.642 223.161 409.379 223.288 410.246 223.343C411.784 223.439 412.97 223.209 413.804 222.653C414.638 222.096 415.088 221.298 415.153 220.258C415.194 219.619 415.081 219.076 414.815 218.63C414.549 218.184 414.185 217.791 413.723 217.452C413.26 217.113 412.729 216.814 412.132 216.553C411.534 216.293 410.925 216.029 410.305 215.762C409.686 215.495 409.079 215.195 408.486 214.865C407.892 214.534 407.371 214.137 406.921 213.673C406.472 213.211 406.12 212.658 405.867 212.017C405.614 211.376 405.515 210.6 405.572 209.69C405.618 208.965 405.785 208.296 406.074 207.683C406.362 207.07 406.77 206.544 407.298 206.104C407.826 205.664 408.478 205.319 409.255 205.069C410.032 204.819 410.926 204.692 411.938 204.691L412.469 201.429C412.483 201.365 412.506 201.304 412.537 201.246C412.568 201.188 412.623 201.14 412.701 201.101C412.78 201.063 412.885 201.039 413.016 201.031C413.147 201.023 413.326 201.026 413.553 201.04C413.792 201.055 413.989 201.078 414.144 201.11C414.3 201.142 414.417 201.184 414.495 201.238C414.573 201.292 414.621 201.352 414.639 201.418C414.656 201.485 414.663 201.561 414.657 201.648L414.096 204.875C414.419 204.928 414.754 205.006 415.101 205.109C415.447 205.213 415.772 205.325 416.074 205.448C416.377 205.57 416.648 205.701 416.89 205.841C417.131 205.982 417.295 206.098 417.382 206.19C417.468 206.283 417.528 206.368 417.561 206.446C417.595 206.524 417.619 206.613 417.635 206.712C417.65 206.811 417.662 206.926 417.67 207.057C417.678 207.188 417.677 207.334 417.667 207.497C417.654 207.703 417.635 207.881 417.609 208.031C417.583 208.182 417.551 208.3 417.513 208.384C417.475 208.469 417.428 208.531 417.371 208.571C417.314 208.611 417.248 208.629 417.172 208.624C417.053 208.616 416.868 208.534 416.617 208.377C416.365 208.22 416.047 208.047 415.662 207.86C415.277 207.673 414.829 207.493 414.318 207.319C413.807 207.146 413.231 207.039 412.592 206.999C411.867 206.953 411.242 206.985 410.719 207.093C410.195 207.202 409.766 207.374 409.431 207.608C409.095 207.843 408.843 208.134 408.674 208.482C408.506 208.83 408.408 209.216 408.382 209.638C408.341 210.288 408.456 210.839 408.726 211.291C408.997 211.743 409.364 212.136 409.827 212.469C410.29 212.803 410.823 213.097 411.427 213.353C412.031 213.608 412.648 213.872 413.278 214.146C413.907 214.419 414.523 214.716 415.122 215.036C415.722 215.357 416.249 215.749 416.704 216.212C417.159 216.676 417.515 217.228 417.774 217.87C418.033 218.511 418.134 219.287 418.077 220.197Z",
    fill: "#FFBF52"
  }))), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M275.604 301.722H267.022V312.57H275.604V301.722Z",
    fill: "#FCC5B6"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M291.471 301.722H282.89V312.57H291.471V301.722Z",
    fill: "#FCC5B6"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M282.93 309.938L279.692 315.12L276.292 317.305L275.158 323.458H294.426L294.227 321.137C294.198 320.801 294.082 320.479 293.891 320.201L293.292 319.329L291.43 310.424C288.716 311.551 285.638 311.396 283.049 310.003L282.93 309.938Z",
    fill: "#382A73"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M266.941 309.857L260.87 315.686L252.784 317.04C252.272 317.079 251.813 317.371 251.561 317.818L249.86 320.827L249.62 320.895C249.091 321.047 248.727 321.53 248.727 322.08V323.417H266.091C267.244 322.698 268.705 322.695 269.861 323.409L270.038 323.519H279.004L278.901 321.7C278.863 321.041 278.547 320.429 278.032 320.017L275.765 310.303L273.937 310.668C271.955 311.065 269.903 310.915 268 310.235L266.941 309.857Z",
    fill: "#382A73"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M279.004 323.672C278.922 323.672 278.855 323.609 278.85 323.527L278.747 321.709C278.712 321.094 278.416 320.522 277.936 320.137L277.895 320.104L277.062 316.536C277.043 316.454 277.094 316.371 277.177 316.352C277.26 316.333 277.343 316.384 277.362 316.467L278.17 319.931C278.694 320.37 279.015 321.008 279.054 321.691L279.157 323.51C279.162 323.595 279.097 323.667 279.013 323.672C279.009 323.672 279.006 323.672 279.004 323.672Z",
    fill: "white"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M250.669 320.819C250.586 320.819 250.517 320.752 250.516 320.668C250.514 320.583 250.581 320.513 250.666 320.511L277.078 319.965C277.153 319.961 277.233 320.03 277.235 320.115C277.237 320.2 277.169 320.271 277.084 320.272L250.673 320.819C250.672 320.819 250.671 320.819 250.669 320.819Z",
    fill: "white"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M279.145 320.515C279.064 320.515 278.996 320.452 278.992 320.37C278.987 320.285 279.052 320.212 279.137 320.208L292.616 319.479C292.699 319.474 292.773 319.54 292.778 319.625C292.783 319.71 292.717 319.782 292.633 319.787L279.154 320.515C279.151 320.515 279.148 320.515 279.145 320.515Z",
    fill: "white"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M265.209 129.831C264.801 129.647 264.266 130.043 264.321 130.486C264.714 130.616 265.129 130.679 265.543 130.674C265.689 130.672 265.849 130.656 265.953 130.553C266.139 130.368 266.003 130.021 265.767 129.907C265.531 129.794 265.252 129.84 264.995 129.89",
    fill: "#1A1A1A"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M226.231 163.107L218.596 156.704L216.884 156.148L208.046 155.956C208.041 156.974 208.701 157.369 209.703 157.547L214.917 158.47L212.713 160.9C212.172 161.497 212.087 162.379 212.504 163.069L214.529 165.807C214.868 166.367 215.501 166.681 216.153 166.611L216.665 166.556C217.377 166.48 218.1 166.807 218.352 166.136L223.107 168.931L225.445 167.344L226.231 163.107Z",
    fill: "#FCC5B6"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M264.84 124.58L265.47 138.434C265.857 142.167 269.003 145.003 272.756 145.003H278.899L282.129 134.295L283.669 131.068C284.983 128.314 285.331 125.198 284.658 122.222L283.833 120.193C283.72 119.692 283.446 119.242 283.054 118.91C277.512 114.22 269.111 113.843 265.154 119.931H265.961C265.066 121.307 264.671 122.948 264.84 124.58Z",
    fill: "#FCC5B6"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M281.178 148.269C281.238 148.653 281.296 149.057 281.158 149.42C280.856 150.211 279.839 150.393 278.994 150.453C277.213 150.58 275.432 150.708 273.651 150.835C273.314 150.859 272.947 150.875 272.672 150.678C272.4 150.482 272.297 150.13 272.214 149.805C271.498 146.974 271.013 144.085 270.766 141.175C270.675 140.106 270.691 138.855 271.533 138.189C272.103 137.737 272.888 137.702 273.616 137.694C275.788 137.67 279.269 137.863 280.012 140.438C280.716 142.879 280.781 145.749 281.178 148.269Z",
    fill: "#FCC5B6"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M292.386 195.978C292.87 196.623 292.386 211.626 292.386 211.626L261.092 212.593L260.608 191.3L292.386 195.978Z",
    fill: "#A6BDFF"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M296.419 150.972C297.194 152.134 305.542 171.397 309.158 179.603C310.075 181.683 309.945 184.073 308.809 186.041C306.986 189.202 303.387 190.894 299.79 190.281L283.03 187.429L296.419 150.972Z",
    fill: "#5C49D8"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M296.419 150.972L282.224 146.294L271.577 146.778L257.381 151.133L256.252 162.748L258.269 189.402C258.428 191.502 259.044 193.543 260.073 195.381C260.518 196.175 261.266 196.755 262.146 196.988L266.72 198.199C273.633 200.029 280.87 200.281 287.894 198.936L290.495 198.438C291.706 198.206 292.777 197.503 293.472 196.484L293.53 196.399C294.366 195.171 294.872 193.749 294.997 192.268L297.71 160.167L296.419 150.972Z",
    fill: "#5C49D8"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M257.381 151.133L244.141 170.147L231.014 163.315C229.792 162.679 228.481 162.231 227.125 161.986L224.652 161.538L223.49 162.703C222.428 163.766 221.929 165.268 222.142 166.755L222.422 168.703L224.169 171.414C224.538 171.986 225.029 172.469 225.608 172.828L244.18 184.326C246.299 185.638 249.045 185.307 250.791 183.529L269.984 163.99L257.381 151.133Z",
    fill: "#5C49D8"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M260.93 207.593L264.963 305.026L266.238 305.451C269.161 306.425 272.337 306.309 275.18 305.124L276.578 304.542L277.384 205.98L260.93 207.593Z",
    fill: "#A6BDFF"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M292.548 207.109L293.032 303.574C289.928 305.677 285.95 306.002 282.547 304.431L281.74 304.058C281.74 304.058 277.92 208.702 277.759 208.218C277.598 207.734 292.548 207.109 292.548 207.109Z",
    fill: "#A6BDFF"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M280.288 141.132L274.113 140.446C273.463 140.373 272.93 139.899 272.782 139.262L271.416 133.389L268.189 132.098L267.705 128.71L265.447 126.129C264.349 125.131 263.866 123.623 264.179 122.172L264.352 121.372C264.746 119.549 265.778 117.927 267.261 116.796C271.812 113.329 278.194 113.621 282.409 117.491L282.785 117.836C284.191 119.127 285.086 120.882 285.303 122.78L285.425 123.841C285.862 127.649 285.171 131.501 283.438 134.919L280.288 141.132Z",
    fill: "#382A73"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M271.345 131.972C271.601 133.155 271.534 134.436 271.157 135.57C271.017 135.992 270.83 136.404 270.546 136.704C270.263 137.004 269.872 137.179 269.504 137.082C269.125 136.982 268.827 136.611 268.656 136.19C268.18 135.014 267.93 132.631 268.592 131.466C269.439 129.977 270.965 130.216 271.345 131.972Z",
    fill: "#FCC5B6"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M284.321 148.23C283.837 147.907 281.417 143.874 281.417 143.874L279.208 143.622C276.952 143.364 274.667 143.67 272.559 144.514L270.125 145.487L269.48 149.197L284.321 148.23Z",
    fill: "#5C49D8"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M270.448 143.529C270.431 143.529 270.414 143.526 270.397 143.52C270.326 143.491 270.291 143.411 270.319 143.339C270.958 141.723 271.364 140.026 271.527 138.296C271.534 138.22 271.602 138.164 271.679 138.171C271.755 138.178 271.811 138.246 271.804 138.323C271.638 140.079 271.226 141.801 270.578 143.441C270.556 143.496 270.504 143.529 270.448 143.529Z",
    fill: "black"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M269.551 137.274C269.308 137.274 269.068 137.211 268.852 137.069C268.788 137.027 268.77 136.941 268.812 136.876C268.854 136.812 268.941 136.795 269.005 136.837C269.582 137.216 270.413 136.856 270.798 136.296C271.221 135.681 271.29 134.88 271.35 134.174C271.357 134.098 271.424 134.042 271.501 134.047C271.577 134.054 271.634 134.121 271.628 134.198C271.567 134.902 271.492 135.778 271.027 136.454C270.7 136.93 270.118 137.274 269.551 137.274Z",
    fill: "black"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M270.132 135.06C270.058 135.06 269.997 135.002 269.993 134.927C269.952 134.074 269.704 133.232 269.275 132.492C269.237 132.426 269.26 132.341 269.326 132.302C269.392 132.264 269.478 132.286 269.516 132.353C269.967 133.13 270.228 134.016 270.271 134.914C270.274 134.991 270.215 135.056 270.138 135.059C270.136 135.06 270.134 135.06 270.132 135.06Z",
    fill: "black"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M270.991 147.462C270.927 147.462 270.869 147.417 270.855 147.352C270.839 147.277 270.887 147.203 270.962 147.187C274.692 146.392 278.511 146.13 282.314 146.409C282.39 146.414 282.448 146.481 282.442 146.557C282.437 146.634 282.37 146.692 282.293 146.686C278.517 146.41 274.724 146.669 271.02 147.459C271.01 147.461 271 147.462 270.991 147.462Z",
    fill: "white"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M242.101 172.534C242.071 172.534 242.04 172.524 242.014 172.504C241.954 172.456 241.945 172.368 241.993 172.308L243.63 170.256C243.678 170.196 243.766 170.186 243.826 170.234C243.886 170.282 243.896 170.37 243.848 170.43L242.21 172.482C242.182 172.516 242.142 172.534 242.101 172.534Z",
    fill: "white"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M257.128 177.073C257.1 177.073 257.071 177.064 257.046 177.045C256.984 177 256.971 176.913 257.017 176.851C257.928 175.622 259.046 174.061 260.033 172.683C260.788 171.629 261.44 170.719 261.827 170.198C261.873 170.137 261.96 170.124 262.021 170.17C262.083 170.216 262.096 170.303 262.05 170.364C261.665 170.883 261.013 171.792 260.259 172.845C259.272 174.223 258.152 175.786 257.24 177.016C257.213 177.053 257.171 177.073 257.128 177.073Z",
    fill: "white"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M261.31 159.336C261.307 159.336 261.305 159.336 261.302 159.336C261.225 159.332 261.167 159.266 261.171 159.189C261.33 156.49 260.162 153.709 258.124 151.932C258.066 151.882 258.06 151.794 258.11 151.736C258.16 151.678 258.248 151.672 258.306 151.723C260.408 153.555 261.613 156.422 261.449 159.205C261.445 159.279 261.383 159.336 261.31 159.336Z",
    fill: "white"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M294.687 188.774C294.682 188.774 294.678 188.774 294.673 188.773C294.597 188.766 294.54 188.698 294.548 188.621C295.292 180.831 295.558 172.914 295.338 165.09C295.336 165.013 295.396 164.949 295.473 164.947C295.549 164.948 295.614 165.005 295.616 165.082C295.836 172.918 295.57 180.846 294.825 188.648C294.818 188.72 294.757 188.774 294.687 188.774Z",
    fill: "white"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M271.28 212.846C271.212 212.846 271.153 212.797 271.142 212.729C271.13 212.653 271.182 212.582 271.258 212.57C276.115 211.801 281.069 211.533 285.981 211.771C286.058 211.775 286.117 211.84 286.113 211.917C286.11 211.993 286.04 212.051 285.968 212.049C281.074 211.811 276.14 212.079 271.302 212.845C271.294 212.846 271.287 212.846 271.28 212.846Z",
    fill: "black"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M269.156 257.09C269.091 257.09 269.033 257.044 269.02 256.978C269.005 256.903 269.054 256.83 269.129 256.814C271.223 256.393 273.357 256.335 275.47 256.643C275.546 256.654 275.599 256.724 275.588 256.8C275.577 256.876 275.505 256.928 275.43 256.918C273.348 256.615 271.246 256.672 269.184 257.087C269.175 257.089 269.165 257.09 269.156 257.09Z",
    fill: "black"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M292.224 256.458C292.216 256.458 292.207 256.457 292.199 256.455C289.754 256.014 287.274 256.01 284.828 256.442C284.753 256.455 284.68 256.405 284.667 256.329C284.653 256.254 284.704 256.181 284.78 256.168C287.258 255.73 289.771 255.734 292.248 256.181C292.324 256.195 292.374 256.268 292.361 256.343C292.348 256.41 292.29 256.458 292.224 256.458Z",
    fill: "black"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M218.358 166.292C218.322 166.292 218.286 166.278 218.259 166.251C217.274 165.253 216.174 164.367 214.988 163.618C214.923 163.577 214.904 163.491 214.945 163.426C214.986 163.361 215.072 163.342 215.137 163.383C216.34 164.143 217.457 165.042 218.457 166.055C218.511 166.11 218.51 166.198 218.456 166.252C218.429 166.279 218.393 166.292 218.358 166.292Z",
    fill: "black"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M215.669 161.491C215.649 161.491 215.629 161.487 215.61 161.479C214.999 161.197 214.319 161.055 213.647 161.063C213.571 161.06 213.507 161.002 213.506 160.926C213.504 160.849 213.566 160.786 213.643 160.785C214.355 160.772 215.078 160.927 215.727 161.226C215.797 161.258 215.827 161.341 215.795 161.411C215.772 161.461 215.721 161.491 215.669 161.491Z",
    fill: "black"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M216.806 160.248C216.787 160.248 216.768 160.245 216.749 160.236C215.875 159.842 214.907 159.662 213.949 159.719C213.871 159.722 213.806 159.665 213.802 159.588C213.797 159.511 213.856 159.446 213.932 159.441C214.935 159.383 215.948 159.57 216.864 159.982C216.934 160.014 216.965 160.096 216.933 160.167C216.91 160.218 216.86 160.248 216.806 160.248Z",
    fill: "black"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M217.875 158.74C217.864 158.74 217.852 158.738 217.841 158.735C216.824 158.478 215.776 158.358 214.729 158.377C214.659 158.379 214.588 158.317 214.587 158.24C214.586 158.163 214.647 158.1 214.724 158.099C215.796 158.079 216.868 158.203 217.909 158.465C217.983 158.484 218.028 158.56 218.01 158.634C217.994 158.698 217.937 158.74 217.875 158.74Z",
    fill: "black"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M282.824 209.31V201.436C282.824 201.36 282.887 201.297 282.963 201.297C283.04 201.297 283.102 201.36 283.102 201.436V209.019L289.764 208.716V201.121C289.764 201.044 289.826 200.982 289.903 200.982C289.98 200.982 290.042 201.044 290.042 201.121V208.982L282.824 209.31Z",
    fill: "black"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M269.109 209.782L268.788 201.284C268.785 201.207 268.845 201.143 268.922 201.14C269.003 201.139 269.063 201.197 269.066 201.273L269.376 209.492L276.201 209.189V201.752C276.201 201.675 276.263 201.613 276.34 201.613C276.416 201.613 276.479 201.675 276.479 201.752V209.455L269.109 209.782Z",
    fill: "black"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M267.034 301.88C266.96 301.88 266.898 301.82 266.896 301.746L265.318 257.271L262.953 200.023C262.95 199.946 263.009 199.881 263.086 199.878C263.163 199.878 263.228 199.935 263.231 200.011L265.596 257.26L267.173 301.736C267.176 301.812 267.116 301.877 267.039 301.88C267.038 301.879 267.036 301.88 267.034 301.88Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_1444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 570,
    height: 380,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManWithCoin);
export default __webpack_public_path__ + "static/media/man_with_coin.f971d829fabe9506c0532d86166726c7.svg";
export { ForwardRef as ReactComponent };